import type { Translations } from './types';

const ja: Translations = {
  nav: {
    approvals: '承認',
    home: 'ホーム',
    search: '検索',
    dashboard: 'ダッシュボード',
    outdoors: '屋外広告',
    campaigns: 'キャンペーン',
    admin: '管理',
    logIn: 'ログイン',
    signUp: '登録',
    logOut: 'ログアウト',
    account: 'アカウント',
    setupBusiness: 'ビジネスを設定',
    searchOutdoors: '屋外広告を検索',
    manageOutdoors: '屋外広告を管理',
    verifyOutdoors: '屋外広告を確認',
    adminPanel: '管理パネル',
    upcomingCampaigns: '近日のキャンペーン',
    getPaid: '支払いを受ける',
    revenue: '収益',
    payments: '支払い',
  },
  common: {
    save: '保存',
    cancel: 'キャンセル',
    back: '戻る',
    next: '次へ',
    done: '完了',
    loading: '読み込み中…',
    error: 'エラーが発生しました',
    confirm: '確認',
    delete: '削除',
    clear: 'クリア',
    edit: '編集',
    add: '追加',
    search: '検索',
    view: '表示',
    create: '作成',
    update: '更新',
    submit: '送信',
    yes: 'はい',
    no: 'いいえ',
    close: '閉じる',
    upload: 'アップロード',
    uploading: 'アップロード中…',
    saving: '保存中…',
    creating: '作成中…',
    noResults: '結果がありません',
    required: '必須',
    optional: '任意',
    copy: 'コピー',
    copied: 'コピーしました！',
    approve: '承認',
    reject: '拒否',
    page: 'ページ',
    of: '/',
    perDay: '/日',
    days: '{{count}} 日',
    days_plural: '{{count}} 日',
    termsAndConditions: '利用規約',
    selectCountry: '国を選択...',
    noCountriesFound: '国が見つかりません',
    notSet: '未設定',
    showPassword: 'パスワードを表示',
    hidePassword: 'パスワードを非表示',
    refresh: '更新',
    new: '新着',
    rowsPerPage: '表示件数',
  },
  home: {
    tagline: '視認性重視のOOHマーケットプレイス',
    heroTitle: 'あなたのブランドが、新たな高みへ',
    heroSubtitle:
      'Scapowは広告看板のオーナーと広告主をつなぎます。実際の屋外スペースを閲覧し、キャンペーンを計画し、ターゲットオーディエンスにリーチ--すべて一つの場所で。',
    browseOutdoors: '屋外広告を見る',
    getStartedFree: '無料で始める',
    featuredOutdoors: '注目の屋外広告',
    viewAll: 'すべて見る →',
    howItWorksTitle: '使い方',
    howItWorksSubtitle: '3つの簡単なステップで、正しいオーディエンスにメッセージを届けましょう。',
    step1Title: '最適なスペースを見つける',
    step1Desc:
      '場所、サイズ、価格で看板を検索。キャンペーン期間の空き状況でフィルタリング。',
    step2Title: 'キャンペーンを作成する',
    step2Desc:
      '複数の屋外広告をキャンペーンに追加し、クリエイティブをアップロードして支払い詳細を取得。',
    step3Title: '結果を追跡する',
    step3Desc:
      'ダッシュボードからキャンペーンの進捗、バナー掲載状況、パフォーマンス指標を監視。',
    builtTitle: '両方のために作られた',
    builtSubtitle:
      '看板のオーナーでも広告主でも、Scapowがサポートします。',
    feature1Title: '屋外広告を掲載する',
    feature1Desc:
      '看板を簡単に掲載し、価格を設定し、写真を追加し、空き状況を管理。',
    feature2Title: 'マップ検索',
    feature2Desc:
      'リアルタイムマップで看板を見つける。ズームインで半径を絞り、ズームアウトでより広い範囲をカバー。',
    feature3Title: 'キャンペーン管理',
    feature3Desc:
      '複数の屋外広告でキャンペーンを作成し、クリエイティブをアップロードし、銀行振込で支払い。',
    feature4Title: '認証済み企業',
    feature4Desc: 'すべての企業は公開前に会社書類で認証されます。',
    feature5Title: 'パフォーマンス追跡',
    feature5Desc:
      '広告主とプロバイダーは共に収益と活動のダッシュボード概要を取得できます。',
    feature6Title: '透明な価格設定',
    feature6Desc: '提供者の料金は1日単位で表示 - 確認前に常に明示されます。',
    ctaTitle: '始める準備はできましたか？',
    ctaSubtitle: '今すぐScapowに参加して、屋外広告市場とつながりましょう。',
    createAccount: 'アカウントを作成',
    browseFirst: 'まず見てみる',
    nearbyOutdoors: 'お近くの屋外広告',
    detectingLocation: '位置情報を検出中…',
    basedOnLocation: '現在地に基づく',
    welcomeBack: 'ようこそ、{{name}}さん',
    fromCompany: '{{company}}より',
    ppPrompt: 'すべての屋外広告は新しいキャンペーンの準備ができていますか？',
    advertiserPrompt: 'キャンペーンを作成する準備はできていますか？',
    noCompanyPrompt: 'すべての機能を利用するために企業を設定してください。',
    goToDashboard: 'ダッシュボードへ',
    inviteFrom: '{{company}}がScapowのチームに参加するよう招待しました。',
    inviteFromDesc: '屋外広告キャンペーンでの協力を始めるために承認してください。',
    inviteAccept: '招待を受け入れる',
    inviteDecline: '辞退する',
    inviteAccepted: 'ようこそ！{{company}}に正式に参加しました。',
    inviteDeclined: '招待を辞退しました。',
    ppHowItWorksSubtitle: '屋外広告スペースを安定した収益源に変えるために必要なすべてが揃っています。',
    ppStep1Title: 'スペースを魅力的に掲載',
    ppStep1Desc: '魅力的な写真、正確な寸法、競争力のある価格で屋外広告を掲載 - 広告主が価値を一目で把握できます。',
    ppStep2Title: 'ブランドに発見される',
    ppStep2Desc: 'あなたの広告スペースは、次のキャンペーンを計画している広告主の検索に表示されます。最適なキャンペーンがあなたを見つけます。',
    ppStep3Title: '証明して報酬を受け取る',
    ppStep3Desc: '広告が設置・稼働したら写真による証明をアップロード。承認後、自動的に支払いが処理されます。',
  },
  auth: {
    login: {
      heroTitle: 'あなたのブランドを世界とつなぐ。新たな高みへ、一歩ずつ。',
      heroSubtitle:
        '看板オーナーと広告主をつなぐプラットフォーム--シンプル、迅速、効果的。',
      title: 'おかえりなさい',
      subtitle: 'アカウントにログインして続けてください',
      email: 'メールアドレス',
      password: 'パスワード',
      forgotPassword: 'パスワードをお忘れですか？',
      resendVerification: '確認メールを再送する',
      signIn: 'ログイン',
      noAccount: 'アカウントをお持ちでないですか？',
      createOne: '作成する',
      invalidCredentials: 'メールまたはパスワードが無効です。もう一度お試しください。',
    },
    register: {
      heroTitle: '屋外広告革命に参加する',
      heroSubtitle:
        '看板オーナーでも広告主でも、Scapowがシンプルにします。',
      title: 'アカウントを作成する',
      subtitle: '今日から屋外広告キャンペーンの管理を始めましょう',
      firstName: '名',
      lastName: '姓',
      email: 'メールアドレス',
      password: 'パスワード',
      confirmPassword: 'パスワードの確認',
      passwordHint: '最低8文字',
      createAccount: 'アカウントを作成',
      alreadyHaveAccount: 'すでにアカウントをお持ちですか？',
      signIn: 'ログイン',
      checkEmail: 'メールをご確認ください',
      checkEmailDesc:
        'メールアドレスに確認リンクを送信しました。クリックしてアカウントを有効化してください。',
      goToLogin: 'ログインへ',
      termsAgreement: '私は次の内容を読み、同意します：',
      termsLink: '利用規約',
    },
    forgotPassword: {
      title: 'パスワードをリセット',
      subtitle: 'メールアドレスを入力するとリセットリンクをお送りします',
      email: 'メールアドレス',
      sendReset: 'リセットリンクを送信',
      backToLogin: 'ログインへ戻る',
      checkEmail: 'メールをご確認ください',
      checkEmailDesc: 'そのアドレスが登録されている場合、まもなくリセットリンクが届きます。',
    },
    resetPassword: {
      title: '新しいパスワードを設定',
      subtitle: '覚えやすい強力なパスワードを選んでください。',
      newPassword: '新しいパスワード',
      confirmPassword: 'パスワードの確認',
      save: '新しいパスワードを保存',
      submit: 'パスワードを更新',
    },
    verifyEmail: {
      verifying: 'メールを確認中…',
      success: 'メールが確認されました！',
      successDesc: 'アカウントが有効になりました。ログインできます。',
      error: '確認に失敗しました',
      errorDesc: 'リンクが期限切れまたは無効な可能性があります。再度登録してください。',
      goToLogin: 'ログインへ',
      successDescBusiness: 'アカウントが有効になりました。ログインしてビジネスを設定できます。',
      returnToLogin: 'ログインに戻る',
      resendButton: '新しい確認リンクをリクエスト',
    },
    resendVerification: {
      title: '確認メールを再送する',
      subtitle: 'メールアドレスを入力すると、新しい確認リンクをお送りします。',
      email: 'メールアドレス',
      send: '確認メールを送る',
      backToLogin: 'ログインに戻る',
      checkEmail: 'メールをご確認ください',
      checkEmailDesc: 'アカウントが確認待ちの場合、新しいリンクを受信トレイに送信しました。',
    },
  },
  business: {
    pendingVerification: 'お客様の企業アカウントは現在審査中です。弊社チームが検証を完了しましたら、Scapow のすべての機能をご利用いただけるようになります。追加書類が必要な場合はご連絡することがございますので、受信トレイをご確認ください。',
    setup: {
      title: 'ビジネスを設定する',
      subtitle: 'Scapowを使用するためにアカウントをビジネスエンティティと関連付けてください。',
      ppTitle: 'スペースプロバイダー',
      ppDesc: '屋外広告スペースを所有しており、貸し出したいと思っています。',
      advertiserTitle: '広告主',
      advertiserDesc: '屋外広告キャンペーンを予約したいと思っています。',
      changeType: '変更 ↩',
      createCompany: '新しい会社を作成',
      createCompanyDesc: 'Scapowに会社を登録する。',
      joinCompany: '既存の会社に参加',
      joinCompanyDesc: 'すでに登録されている会社へのアクセスをリクエストする。',
      registerTitle: '会社を登録する',
      companyName: '会社名',
      vatNumber: '法人番号/税番号',
      companyEmail: '会社のメール',
      currency: '希望通貨',
      currencyHint: 'ISO通貨コード（例：EUR、USD、JPY）',
      country: '国',
      proofDocument: '会社証明書類',
      proofHint: 'PDF、JPG、またはPNG',
      uploadProof: 'クリックして会社証明書をアップロード',
      createCompanyBtn: '会社を作成',
      bankTitle: '銀行情報',
      bankSubtitlePP: 'IBANおよびSWIFT/BICは、屋外広告キャンペーンが開始された際の支払いに使用されます。',
      bankSubtitleAdvertiser: 'IBANおよびSWIFT/BICは、必要に応じた返金処理に使用されます。',
      findTitle: '会社を見つける',
      searchPlaceholder: '会社名で検索…',
      noCompanies: '会社が見つかりません。名前で検索してください。',
      requestAccess: 'アクセスをリクエスト',
      requested: 'リクエスト済み',
      accessSentMsg:
        'アクセスリクエストが送信されました！会社の管理者が承認する必要があります。承認されると通知されます。',
      pendingTitle: 'アクセスリクエスト保留中',
      pendingDesc: '{{name}} への参加リクエストが審査中です。承認されると通知されます。',
      cancelRequest: 'リクエストをキャンセル',
      requestCancelled: 'アクセスリクエストをキャンセルしました。',
      connectingToEntity: '組織に接続中…',
      accessApproved: 'アクセスリクエストが承認されました！チームの一員になりました。',
      accessRejected: 'アクセスリクエストが却下されました。別のビジネスエンティティを作成または参加してください。',
      orSetupYourOwn: 'または、以下から企業を登録するか、既存の企業に参加してください。',
      invitationsTitle: '保留中の招待',
      invitationsSubtitle: 'ビジネスへの参加招待があります。以下で承認または拒否してください。',
      invitedOn: '招待日',
      acceptInvitation: '承認',
      declineInvitation: '拒否',
      invitationAccepted: '招待を承認しました！組織に接続中…',
      invitationDeclined: '招待を拒否しました。',
    },
    details: {
      title: '会社詳細',
      subtitle: '会社の登録情報と銀行情報を管理します。',
      registrationTitle: '登録詳細',
      companyName: '会社名',
      vatNumber: '法人番号/税番号',
      companyEmail: '会社のメール',
      currency: '希望通貨',
      country: '国',
      portugueseRegion: 'ポルトガル地域',
      regionContinent: '本土',
      regionAzores: 'アゾレス諸島',
      regionMadeira: 'マデイラ',
      replaceProof: '証明書類を置き換える',
      uploadProof: 'クリックして新しい証明書類をアップロード',
      saveChanges: '変更を保存',
      addressSectionTitle: '住所',
      addressLine: '住所',
      addressLinePlaceholder: '東京都千代田区1-2-3',
      city: '市区町村',
      postCode: '郵便番号',
      state: '州',
      stateHint: 'USD口座の場合は必須です',
      selectState: '州を選択',
      bankTitle: '銀行詳細',
      bankSubtitle: '広告主からの支払いを受け取るために使用されます。',
      bankSubtitlePP: 'IBANおよびSWIFT/BICはキャンペーン開始時の支払いに使用されます。',
      bankSubtitleAdvertiser: 'IBANおよびSWIFT/BICは必要な場合の返金に使用されます。',
      bankClickUnlock: 'ロック中 - クリックして編集',
      iban: 'IBAN',
      swift: 'SWIFT / BIC',
      ibanHint: '国際銀行口座番号...',
      swiftHint: '8または11文字：銀行コード（4）+国コード（2）+場所コード（2）+支店コード（3、任意）',
      accountNumber: '口座番号',
      accountNumberHint: '米国の銀行口座番号(4~17桁)',
      saveBankDetails: '銀行情報を保存',
      verifiedLocked: '会社名、VAT番号、国は認証後にロックされます。',
      verifiedBadge: '認証済み',
      pendingReviewTitle: '承認待ち',
      pendingReviewDesc: '企業登録は現在審査中です。チームが承認次第、プラットフォームへのフルアクセスが付与されます - リアルタイムでお知らせします。',
      verifiedTitle: '本人確認済み',
      verifiedDesc: '貴社の身元確認が完了しました。追加書類は不要です。',
      proofCardTitle: '確認書類',
      proofCardDesc: 'アカウントの審査をサポートするため、会社の登記書類をアップロードしてください。チームが確認し、追加書類が必要な場合はご連絡いたします。',
      proofCardSubmit: '審査に提出',
      proofCardSuccess: '書類が正常に提出されました。チームが確認し、必要に応じてご連絡いたします。',
      proofCardValidatingTitle: '書類審査中',
      proofCardValidatingDesc: '確認書類を受領し、現在チームが審査中です。審査が完了次第、ご連絡いたします。',
      proofCardProcessingTitle: 'ファイルを処理中',
      proofCardProcessingDesc: '書類を受領し、自動確認を行っています。もうしばらくお待ちください。',
      proofCardReplaceFile: '間違ったファイルを送信しましたか？差し替える',
    },
  },
  search: {
    instantBookingHint: '提供者の承認を待たずに即時確定',
    priceFilterLocked: '価格フィルターは、ログインして事業者に紐付けられると利用できます。',
    title: '屋外広告を検索',
    subtitle: 'マップ上で広告スペースを見つける',
    filters: 'フィルター',
    minWidth: '最小幅（m）',
    maxWidth: '最大幅（m）',
    minHeight: '最小高さ（m）',
    maxHeight: '最大高さ（m）',
    minPrice: '最低価格（€/日）',
    maxPrice: '最高価格（€/日）',
    providerName: 'プロバイダー名',
    clearFilters: 'フィルターをクリア',
    noResults: 'この地域に屋外広告が見つかりません',
    noResultsDesc: 'マップの表示範囲を広げるか、フィルターを調整するか、キャンペーン期間を延長して空き状況を広げてみてください。',
    addToCart: 'カートに追加',
    inCart: 'カートに入っています',
    selectDates: '日付を選択',
    from: '開始',
    to: '終了',
    results: '件',
    loading: '屋外広告を読み込み中…',
    resultsTab: '結果 ({{count}})',
    mapTab: '地図',
    searching: '検索中…',
    found: '{{count}} 件の屋外広告が見つかりました',
    found_plural: '{{count}} 件の屋外広告が見つかりました',
    moveMap: 'マップを移動して結果を更新',
    noticePeriodHint: '一部の掲載スペース提供者はキャンペーン開始前に最低限の予告期間や最短レンタル期間を必要とする場合があり、空き状況や検索結果に影響することがあります。',
    noOutdoorsFound: '広告スペースが見つかりません',
    noOutdoorsFoundAdjustDates: '開始日と終了日を調整するか、縮小してみてください。',
    noOutdoorsFoundAdjustFilters: '縮小するか、フィルターを調整してください。',
    inCampaign: 'キャンペーン中',
    attributes: '近くにある',
    withDiscounts: 'ボリュームディスカウントあり',
    illuminated: '照明あり限定',
    illuminatedHint: '屋外広告に照明あり（夜間など）',
    containsDiscounts: 'ボリュームディスカウント',
    containsDiscountsDesc: 'この広告スペースは段階的な料金体系を採用しています - 予約日数が多いほど、1日あたりの料金が安くなります。',
  },
  outdoor: {
    startAtMonthFirstDay: '月の1日から開始',
    startAtMonthFirstDayHint: '予約は月の1日から開始する必要があります。「月単位のみ」と併用すると、暦月単位（1日から末日まで）での予約になります。',
    acceptingToastOn: '{{name}}は新しいキャンペーンの受付を開始しました。',
    acceptingToastOff: '{{name}}を一時停止しました。検索に表示されず、新規予約も受け付けません。',
    acceptingToastBulkOn: '{{count}}件のアウトドアで新しいキャンペーンの受付を開始しました。',
    acceptingToastBulkOff: '{{count}}件のアウトドアを一時停止しました。検索に表示されず、新規予約も受け付けません。',
    fullMonthRequired: '月単位のみ',
    fullMonthRequiredHint: '広告主は月単位で予約します。開始日から翌月の同じ日まで（1日に開始した場合はその月の末日まで）で、連続する月であれば何か月でも予約できます。',
    fullMonthTooltip: '月単位で予約 - 開始日から以降の月の同じ日まで。',
    stepsTitle: 'アウトドアの設定',
    stepNotSet: '未設定',
    stepLocationSet: '位置を設定済み',
    stepNoticeSummary: '事前通知：{{count}}日',
    stepPhotosSummary: '写真：{{count}}枚',
    stepPhotosNone: '写真はまだありません',
    stepBlockedSummary: 'ブロック期間：{{count}}件',
    stepOptional: '任意',
    stepFeaturesSummary: '選択済み：{{count}}',
    fixHighlightedFields: '修正が必要な項目があります。該当するステップを開きました。',
    instantBooking: '即時予約',
    instantBookingTooltip: '提供者の確認を待たずに、すぐに予約が確定します。',
    instantBookingHint: '広告主はあなたの承認を待たずに、このアウトドアをすぐに予約できます。予約ごとに確認したい場合はオフのままにしてください。',
    kmAway: '{{distance}} km先',
    productionCost: '制作費',
    productionCostIncludes: '印刷・設置などの費用を含む',
    priceHiddenTitle: '日額料金はビジネスアカウント限定です',
    priceHiddenMessage: 'アウトドアの日額料金を表示するには、ログインし、事業者（スペース提供者または広告主）に紐付けられていることを確認してください。',
    manageTitle: '屋外広告を管理',
    addNew: '新しい広告スペースを追加',
    noOutdoors: 'まだ広告スペースがありません',
    noOutdoorsDesc: '最初の看板を追加して予約を受け付けましょう。',
    addFirst: '最初の広告スペースを追加',
    editTitle: '広告スペースを編集',
    createTitle: '新しい広告スペースを追加',
    listSubtitle: 'Scapowに看板を掲載する。',
    editSubtitle: '看板の詳細を更新する。',
    location: '場所',
    latitude: '緯度',
    longitude: '経度',
    name: '名前',
    namePlaceholder: '例：銀座通り – 看板A',
    description: '説明',
    descriptionPlaceholder: '繁華街の優良広告看板、交通量の多いエリア…',
    dimensions: 'サイズと仕様',
    width: '幅（m）',
    height: '高さ（m）',
    length: '長さ（m）',
    aspectRatio: 'クリエイティブのアスペクト比',
    aspectRatioHint: '幅 ÷ 高さから自動計算',
    bleed: '塗り足し (m)',
    bleedHint: '最終的な断裁線を超えた印刷領域。断裁後に綺麗な端を確保します。',
    illuminated: '照明あり',
    illuminatedHint: 'この屋外広告は照明が付いており、夜間も視認可能です。',
    currency: '通貨',
    currencyLockedHint: '掲載プロバイダーアカウントの通貨に基づき設定されます。',
    pricing: '価格設定',
    excludeVat: '税抜',
    vatIncluded: '税込',
    pricePerDay: '1日あたりの価格',
    volumeDiscounts: 'ボリュームディスカウント',
    addDiscount: '追加',
    daysArrow: '日 →',
    percentOff: '% オフ',
    photos: '場所の写真',
    photosHint: '写真はアップロードまたは削除すると自動的に保存されます。',
    uploadPhotos: 'クリックして場所の写真をアップロード',
    addMorePhotos: '写真を追加',
    currentPhotos: '現在の写真',
    uploadingPhotos: '写真をアップロード中...',
    photosUploaded: '写真が正常にアップロードされました',
    deletePhotoTitle: '写真を削除しますか？',
    deletePhotoConfirm: 'この写真はこのアウトドアから完全に削除されます。',
    filesSelected_one: '{{count}} ファイル選択済み',
    filesSelected_other: '{{count}} ファイル選択済み',
    blockedTimes: 'ブロック期間',
    blockedTimesDesc:
      '広告スペースが利用できない日付をブロック（メンテナンス、外部予約など）。',
    blockedTimesOverlapNote: '期間は互いに重複できず、既存のキャンペーン予約とも重複できません。',
    blockFrom: 'ブロック開始',
    blockUntil: 'ブロック終了',
    addBlockedTime: 'ブロック期間を追加',
    noBlockedTimes: 'ブロック期間なし',
    occupiedByCampaign: 'キャンペーンにより予約済み',
    unsaved: '未保存',
    unsavedChanges: '{{count}} 件の未保存の変更 - 屋外広告を保存して適用してください',
    selectBlockedDates: '開始日と終了日を選択してください。',
    legalDeclaration: 'この屋外広告スペースに対する法的権利を有し、商業的に掲載する権限があり、適用されるすべての法律・許可・規制を遵守していることを宣言します。',
    legalDeclarationRequired: '掲載前に、この屋外広告スペースに対する法的権利を確認してください。',
    createOutdoor: '広告スペースを作成',
    saveChanges: '変更を保存',
    deleteTitle: '広告スペースを削除',
    deleteConfirm: 'この広告スペースを削除しますか？この操作は取り消せません。',
    hidden: '非表示',
    visible: '表示',
    viewDetails: '詳細を見る',
    bookingRules: '予約ルール',
    bookingRulesDesc: 'キャンペーン開始日前に広告主が満たすべきリードタイム要件を設定します。',
    minimumNoticeDays: '最低事前通知日数',
    minimumNoticeDaysHint: 'キャンペーンは開始日の少なくともこの日数前までに、支払いと広告素材のアップロードを完了する必要があります。',
    minimumDays: '最低賃貸日数',
    minimumDaysHint: '広告主がこのスペースを賃貸しなければならない最低日数。',
    acceptingCampaigns: '新規キャンペーンを受付中',
    acceptingCampaignsOn: 'この屋外広告は検索に表示され、キャンペーンに追加できます。',
    acceptingCampaignsOff: 'この屋外広告は検索に表示されず、新規予約を受け付けません。',
    acceptingBadge: 'キャンペーン受付中',
    notAcceptingBadge: 'キャンペーン停止中',
    notAcceptingMsg: '現在この屋外広告は新規キャンペーンを受け付けていません。',
    unavailableForDates: '選択した日程ではこの屋外広告は利用できません。',
    paused: '一時停止中',
    accepting: '受付中',
    availabilityToggleTooltip: 'この屋外広告がキャンペーンに利用可能かどうか。現在の状態：{{state}}',
    availabilityStateOn: '利用可能',
    availabilityStateOff: '利用不可',
    toggleError: 'キャンペーンの表示設定の更新に失敗しました。',
    bulkAccept: 'このページのすべての屋外広告でキャンペーン受付を有効にする',
    bulkPause: 'このページのすべての屋外広告でキャンペーン受付を停止する',
    commissionNote: '広告主には<bold>{{currency}} {{advertiserPrice}}/日</bold>が表示されます - あなたの{{currency}} {{basePrice}}に<bold>Scapow手数料{{rate}}%</bold>を加えた金額です。',
    advertiserPaysLabel: '広告主が支払う金額',
    advertiserPaysDesc: 'Scapow手数料{{rate}}%を含む',
    youReceiveLabel: '{{name}} が受け取る金額',
    youReceiveDesc: 'プラットフォーム手数料{{rate}}%差引後（手数料に消費税がかかる場合があります）',
    searchByAddress: '住所で検索',
    dragPin: 'ピンをドラッグして正確な位置を微調整してください。',
    myOutdoors: '私の広告スペース',
    myOutdoorsSubtitle: '看板在庫を管理',
    viewCalendarTooltip: 'このアウトドア広告のブロック日を確認',
    calendarModalTitle: 'カレンダー - {{name}}',
    addOutdoor: '広告スペースを追加',
    searchByName: '名前で検索…',
    deleteConfirmNamed: '"{{name}}" を削除してもよろしいですか？この操作は取り消せません。',
    specifications: '仕様',
    creativeRatio: 'クリエイティブの比率',
    coordinates: '座標',
    price: '価格',
    plusVat: '+ 消費税',
    unavailableDates: '利用不可日',
    duration: '期間',
    addToCampaign: 'キャンペーンに追加',
    goToCampaign: 'キャンペーンへ移動',
    signInToAdd: 'このアウトドアをキャンペーンに追加するにはログイン/登録してください',
    bookingsCalendarTitle: '予約カレンダー',
    bookingsCalendarSubtitle: 'キャンペーンの開始・掲出中・終了がひと目でわかります。日付を選ぶと、その日に予約されているアウトドアを表示します。',
    legend_starting: 'キャンペーン開始',
    legend_startingDesc: '予約の掲出が始まる日',
    legend_running: 'キャンペーン掲出中',
    legend_runningDesc: 'アウトドアが掲出されています',
    legend_finishing: 'キャンペーン終了',
    legend_finishingDesc: '予約の最終日',
    legend_blocked: 'ブロック済みの日付',
    legend_blockedDesc: '利用不可に設定したアウトドア',
    legend_none: '予約なし',
    legend_noneDesc: '予約されているアウトドアはありません',
    legend_mixed: '色の分割：その日に複数が該当',
    calendarToday: '今日',
    selectDayHint: '日付を選ぶと予約が表示されます。もう一度クリックすると解除されます。',
    clearDateSelection: '日付の選択を解除',
    dailyStatesError: '今月の予約を読み込めませんでした。更新してください。',
    searchBookedByName: '予約済みアウトドアを名前で検索…',
    clearSearch: '検索をクリア',
    bookedOutdoorsCount: '予約済みアウトドア：{{count}}件',
    noBookingsOnDate: 'この日に予約されているアウトドアはありません',
    noBookedOutdoorsMatch: 'この日に「{{name}}」に一致する予約済みアウトドアはありません',
    noBookingsOnDateHint: '別の日を選ぶか、日付を解除してすべてのアウトドアを表示してください。',
    bookingPeriod: '予約期間',
    logIn: 'ログイン',
    register: '登録',
    selectCampaignToAdd: 'このスペースを追加するにはキャンペーンを選択してください',
    changeCampaign: '変更',
    alreadyInCampaign: 'すでにキャンペーン中',
    billboardFallback: '屋外広告看板',
    bookMoreThanDays: '{{count}} 日以上予約',
    percentageOff: '{{percentage}}% オフ',
    comingSoon: 'まもなく広告スペースが追加されます！',
    attributes: '近くにある',
    attributesHint: '広告主があなたをより早く見つけられるようにしましょう。近隣の特徴をタグ付けして、検索結果での露出を高めましょう。',
  },
  outdoorDetail: {
    productionCost: '制作費',
    bookingTitle: 'この広告スペースを予約',
    startDate: '開始日',
    endDate: '終了日',
    estimatedCost: '見積もり費用',
    addToCart: 'カートに追加',
    inCart: 'すでにカートに入っています',
    specs: '仕様',
    dimensions: 'サイズ',
    aspectRatio: '必要なアスペクト比',
    pricePerDay: '1日あたりの価格',
    location: '場所',
    blockedTimes: 'ブロック期間',
    discounts: 'ボリュームディスカウント',
    noBlockedTimes: 'ブロック期間なし',
    noDiscounts: '利用可能なディスカウントなし',
    photos: '写真',
    days: '日',
    total: '合計',
    discount: '割引',
    campaignBookings: 'キャンペーン予約',
    inCampaign: 'キャンペーン中',
    minimumNoticeInDays: '最低予約通知期間',
  },
  campaign: {
    methodFlowLabel: 'お支払い方法',
    methodFirstPayment: '初回のお支払い',
    methodCard: 'カード',
    methodThenMonthly: '以降は毎月',
    methodThenTrimonthly: '以降は3か月ごと',
    methodDirectDebit: '口座振替',
    searchByName: 'キャンペーン名で検索…',
    clearSearch: '検索をクリア',
    resultsSummary: '結果：{{total}}件 · {{pages}}ページ中{{page}}ページ目',
    noSearchResults: '「{{name}}」に一致するキャンペーンはありません',
    noSearchResultsHint: 'つづりを確認するか、別の名前をお試しください。',
    eventFeedbackReceived: '提供者がキャンペーンのアウトドアについて回答しました。',
    eventConfirmationUpdated: 'キャンペーンの確認が完了しました。新しいステータスをご確認ください。',
    eventViewCampaign: 'キャンペーンを見る',
    planTrimonthlyTitle: '3か月ごとに支払う',
    planTrimonthlyDesc: '制作費と最初の3か月分を今お支払い。以降は3か月ごとに、その期間の初日に口座振替で引き落とされます。',
    visitCampaignPage: 'キャンペーンページへ',
    payStepNotice: 'お支払い時にアウトドアの空き状況を再確認します。変更があった場合は、請求前にお知らせします。',
    removeOutdoor: 'このアウトドアを削除',
    noOutdoorsYetDesc: '地図からキャンペーンに使うアウトドアを探し、日程を選択してください。',
    creativesNeedOutdoors: '先にアウトドアを追加してください。必要なクリエイティブはサイズによって決まります。',
    stepAnnounce: 'ステップ{{n}}/{{total}}：{{step}}',
    stepsDone: '{{total}}件中{{done}}件完了',
    stepDone: '完了',
    stepToDo: '未完了',
    stepPrevious: '戻る：{{step}}',
    stepNext: '次へ：{{step}}',
    stepOutdoorsSummary: 'アウトドア：{{count}}件',
    stepCreativesSummary: '{{total}}件中{{done}}件準備完了',
    stepTermsAccepted: '同意済み',
    stepTermsPending: '未同意',
    stepPendingHint_outdoors: '続行するには、アウトドアを1件以上追加してください。',
    stepPendingHint_creatives: '必要なクリエイティブをすべてアップロードし、承認を受ける必要があります。',
    stepPendingHint_terms: '規約に同意すると、お支払いに進めます。',
    goToPayment: 'お支払いへ',
    acceptTermsStepLabel: 'このキャンペーンの利用規約を読み、同意します。',
    payStepTitle: '確認してお支払い',
    payStepMissingTitle: 'お支払いには次のステップを完了してください：',
    payStepTotal: 'キャンペーン合計',
    scheduleTitle: '支払いスケジュール',
    scheduleTotal: '合計 {{amount}}',
    scheduleFullPayment: '一括払い',
    scheduleFirstPayment: '初回のお支払い · {{month}}',
    scheduleDueAtCheckout: '決済時に請求',
    scheduleAuthorisedAtCheckout: '決済時に与信、提供者の確認後に請求',
    scheduleDueOn: '{{date}}に請求予定',
    schedulePaidOn: '{{date}}に支払済み',
    scheduleProcessing: '処理中 - 口座振替の完了には数日かかります',
    scheduleFailed: '支払いに失敗しました',
    scheduleCancelled: 'キャンセル - 請求されません',
    scheduleSplit: '制作費 {{production}} · 掲出日数分 {{ads}}',
    scheduleVatIncluded: '金額はすべて税込みです。',
    paymentsTitle: 'お支払い',
    paymentsPaidSoFar: 'これまでの支払額',
    paymentsRemaining: '残り {{amount}}',
    paymentsFailedNotice: '口座振替が完了しませんでした。キャンペーンが中断されないよう、銀行口座をご確認いただくか、お問い合わせください。',
    paymentPlanTitle: 'お支払い方法を選択',
    paymentPlanSubtitle: 'お支払い前に選択してください。支払うまで変更できます。',
    planTotalTitle: '一括払い',
    planTotalDesc: 'キャンペーン全体を1回でお支払い。',
    planMonthlyTitle: '月払い',
    planMonthlyDesc: '制作費と最初の月分を今お支払い。以降は毎月1日に口座振替で引き落とされます。',
    paymentPlanError: '支払いプランを更新できませんでした。',
    checkoutAllInstant: 'すべてのアウトドアが即時予約です：決済時に請求され、キャンペーンはすぐに確定します。',
    checkoutNeedsConfirmation: '{{total}}件中{{count}}件のアウトドアは提供者の確認が必要です。決済時はカードの与信のみで、提供者が確認した後、承認されたアウトドア分のみ請求されます。',
    mandateStepTitle: 'ステップ1/2 · 口座振替を設定',
    mandateStepDesc: '次に、最初のお支払いをカードで行います。',
    confirmingTitle: '提供者の確認待ち',
    confirmingDesc: 'カードは与信済みで、まだ請求されていません。提供者が承認したアウトドア分のみ請求されます。',
    awaitingDecisionTitle: '一部のアウトドアが利用できません',
    awaitingDecisionDesc: '承認されたアウトドアで進めるか、キャンペーンをキャンセルして支払いを解除してください。',
    providersAnswerBy: '提供者の回答期限：{{date}}',
    decideBy: '{{date}}までに決定してください。決定がない場合、キャンペーンはキャンセルされ、請求はありません。',
    feedbackCount_approved: '承認済み：{{count}}',
    feedbackCount_confirming: '回答待ち：{{count}}',
    feedbackCount_unavailable: '利用不可：{{count}}',
    feedbackCount_expired: '期限内に回答なし：{{count}}',
    proceedWithApproved: '承認されたアウトドアで進める',
    proceedNoneApproved: 'まだ承認されたアウトドアはありません。',
    removeConfirmingHint: '回答待ちのアウトドアはまだ削除できます。',
    proceedModalTitle: '承認されたアウトドアで進めますか？',
    proceedOutdoorsLabel: '予約されるアウトドア',
    proceedOutdoorsValue: '{{total}}件中{{approved}}件',
    proceedChargedLabel: '請求額',
    proceedTotalMonthlyLabel: 'キャンペーン合計',
    proceedModalNote: 'この金額が今カードに請求されます。',
    proceedModalMonthlyNote: '最初のお支払いは今、残りは分割で口座振替により引き落とされます。',
    proceedModalDropped: 'その他のアウトドア（{{count}}件）はこのキャンペーンから削除されます。',
    proceedSuccess: 'キャンペーンが確定しました。',
    cancelDecisionTitle: 'このキャンペーンをキャンセルしますか？',
    cancelDecisionDesc: '与信済みの支払いは解除され、請求はありません。すべてのアウトドアは他の広告主に開放されます。',
    unavailableTitle: '利用できるアウトドアがありませんでした',
    unavailableDesc: '提供者がこれらの日程を確認できなかったため、請求はありません。別の日程やアウトドアをお試しください。',
    feedback_CONFIRMING: '提供者の回答待ち',
    feedback_APPROVED: '承認済み',
    feedback_UNAVAILABLE: '利用不可',
    feedback_EXPIRED: '回答なし',
    creativeThumbnailAlt: 'キャンペーン「{{name}}」のクリエイティブ',
    title: 'キャンペーン',
    newCampaign: '新しいキャンペーン',
    newCampaignTooltip: 'クリックして新しいキャンペーンを作成',
    mustRegisterAsAdvertiser: 'キャンペーンを作成するには広告主として登録する必要があります',
    noCampaigns: 'まだキャンペーンがありません',
    noCampaignsDesc: '最初のキャンペーンを作成して屋外広告を始めましょう。',
    browseSpaces: '広告スペースを見る',
    status: 'ステータス',
    from: '開始',
    to: '終了',
    filter: 'フィルター',
    clearFilter: 'フィルターをクリア',
    outdoorSlots: '屋外広告',
    outdoorsColHeader: '屋外広告数',
    startDate: '開始日',
    endDate: '終了日',
    paginationRange: 'キャンペーン {{from}}-{{to}} / {{total}}',
    creatives: 'クリエイティブ',
    payment: '支払い',
    deleteTitle: 'キャンペーンを削除',
    deleteConfirm: 'このキャンペーンを削除しますか？この操作は取り消せません。',
    uploadCreative: 'クリエイティブをアップロード',
    removeCreative: '削除',
    deletingCreative: 'クリエイティブを削除中…',
    creativeRatioMismatch: '画像の縦横比が必要な{{ratio}}形式と一致しません。正しい比率の画像またはPDFをアップロードしてください。',
    getPaymentDetails: '支払い詳細を取得',
    requiredRatios: '必要なクリエイティブ比率',
    iban: 'IBAN',
    reference: '支払い参照番号',
    viewCampaign: '表示',
    loading: 'キャンペーンを読み込み中…',
    noSlots: 'このキャンペーンに広告スペーススロットがありません。',
    noCreatives: 'まだクリエイティブがアップロードされていません。',
    subtitle: '屋外広告キャンペーンを管理',
    noFound: 'キャンペーンが見つかりません',
    noFoundDesc: 'まず広告スペースをカートに追加して最初のキャンペーンを作成してください。',
    browseOutdoors: '広告スペースを探す',
    outdoorsCount: '{{count}} 件の広告スペース',
    outdoorsCount_plural: '{{count}} 件の広告スペース',
    creativesCount: '{{count}} 件のクリエイティブ',
    paymentLabel: '支払い: {{status}}',
    backToCampaigns: 'キャンペーンに戻る',
    checklistTitle: 'キャンペーンチェックリスト',
    checklistOutdoors: 'キャンペーン用の広告スペースを選択',
    checklistCreatives: 'クリエイティブを追加',
    checklistTerms: '利用規約に同意する',
    checklistPay: 'キャンペーンの支払い',
    acceptTermsPrefix: '以下に同意します:',
    acceptTermsLink: '利用規約',
    acceptTermsRequiredHint: 'このキャンペーンの支払いを行う前に、利用規約に同意する必要があります。',
    advertiserTermsModalTitle: '広告主およびキャンペーンに関する利用規約',
    advertiserTermsModalHint: '広告主およびキャンペーンに特に適用される利用規約の条項です。',
    viewFullTerms: '利用規約全文を見る',
    outdoorsHeader: '広告スペース ({{count}})',
    noOutdoorsYet: 'まだ広告スペースが追加されていません。',
    requiredAspectRatios: '必要なクリエイティブの縦横比',
    recResolution: '推奨: {{w}}×{{h}} cm @ {{dpi}} dpi (1:{{scale}})',
    recInclBleed: '塗り足し込み',
    dimensionsCalculatorBleedNote: 'この掲載スペースには各辺に{{bleed}} cmの塗り足しがあるため、サイズは印刷領域全体の{{w}} × {{h}} mを対象としています(表示領域は{{trimW}} × {{trimH}} m)。',
    orientationLandscape: '横向き',
    orientationPortrait: '縦向き',
    dimensionsCalculatorTooltip: '可能なクリエイティブサイズを計算',
    dimensionsCalculatorTitle: '比率{{ratio}}のクリエイティブ用サイズ計算機',
    dimensionsCalculatorHint: '幅または高さ(センチメートル)を変更すると、もう一方の辺がこの比率を保つように自動的に更新されます。常に300 dpiで作業し、掲載スペースの実寸の1:10スケールを推奨します。',
    dimensionsCalculatorWidthLabel: '幅(cm)',
    dimensionsCalculatorHeightLabel: '高さ(cm)',
    dimensionsCalculatorDpiLabel: '印刷解像度',
    dimensionsCalculatorScaleHint: 'スケール: 1:{{scale}} - 1:10以上(スケール数値が小さいデザイン)を推奨します。',
    dimensionsCalculatorExportHint: 'ファイルは {{w}} × {{h}} px で書き出してください。',
    dimensionsCalculatorMinQualityWidth: '印刷品質に対して小さすぎます - 1:{{scale}} スケールのデザインには最低 {{min}} cm が必要です。',
    dimensionsCalculatorMinQualityHeight: '印刷品質に対して小さすぎます - 1:{{scale}} スケールのデザインには最低 {{min}} cm が必要です。',
    processingImage: '画像を処理中...',
    noCreativesYet: 'まだクリエイティブがアップロードされていません',
    creativesNote: 'キャンペーン期間中、屋外広告ディスプレイに掲載される画像です。',
    clickToUpload: 'クリックしてアップロード',
    creativeValid: '承認済み',
    creativeUnderReview: '審査中',
    creativeInvalid: '無効',
    deleteCreativeTitle: 'クリエイティブを削除しますか？',
    deleteCreativeBody: 'このクリエイティブは承認済みまたは審査中です。削除するとキャンペーンから削除され、再アップロードが必要になります。',
    campaignInfo: 'キャンペーン情報',
    details: '詳細',
    requestPayment: '支払いをリクエスト',
    paymentDetails: '支払い詳細',
    currency: '通貨',
    bankTransferDetails: '銀行振込の詳細',
    amount: '金額',
    importantRef: '⚠️ 重要 - 支払い参照番号',
    refNote: '自動的に照合されるよう、振込の説明欄にこの参照番号を必ず記入してください。',
    deleteCampaign: 'キャンペーンを削除',
    deleteCampaignDesc: 'このキャンペーンとすべての関連データが完全に削除されます。この操作は取り消せません。',
    addOutdoor: '屋外広告を追加',
    outdoorAdded: '屋外広告をキャンペーンに追加しました',
    selectOutdoor: '屋外広告を選択',
    outdoorDateConflict: 'この屋外広告は、このキャンペーンで重複する日程にすでに予約されています。別の日程を選択してください。',
    alreadyInCampaign: 'キャンペーン中',
    name: '名前',
    outdoorSubtotal: '小計',
    bankTransferNoticeTitle: 'キャンペーンのお支払いが必要です',
    bankTransferNotice: 'キャンペーンの有効化およびすべての掲出枠の正式予約は、お支払いの全額確認後にのみ行われます。「確認して支払う」をクリックして手続きを進めてください。なお、掲出枠の空き状況はお支払い時に再確認されます。キャンペーンに追加した時点で空きがあった枠も、その後に確保されなくなる場合があります。',
    requestPaymentDisabledHint: '支払いをリクエストする前に、{{count}}件の必須クリエイティブをすべてアップロードし、検証済み（ステータス：有効）にする必要があります。',
    outdoorRemoved: '屋外広告をキャンペーンから削除しました。',
    removeOutdoorConfirm: 'このアウトドアをキャンペーンから削除してもよろしいですか？この操作は元に戻せません。',
    qualityFail: '解像度が低すぎます - ファイルはアップロードされていません',
    qualityWarn: 'アスペクト比が一致しません - 画像が切り取られたり余白が付く可能性があります',
    qualityAspectMismatch: 'アスペクト比 {{actual}} vs {{expected}}（屋外広告）',
    qualityUploadAnyway: 'このままアップロード',
    qualityConfirmHint: '画像はこのフォーマットに合わせて切り取られたり余白が付く可能性があります。',
    qualityDetailFail: 'このファイルは {{outdoorW}} × {{outdoorH}} m の掲載スペースでは {{achievedScale}} 相当の鮮明さしかありません。',
    qualityTargetFail: 'このフォーマットには {{w}} × {{h}} cm(1:{{scale}} スケール、{{dpi}} dpi)でデザインしてください。',
    recResolutionPx: '推奨: {{w}}×{{h}}px @ {{dpi}} dpi',
    dimensionsCalculatorHintPx: '幅または高さを変更すると、もう一方の辺がこの比率を保つように自動的に更新されます。実効DPIも更新されるため、印刷品質を保てる別のサイズを見つけることができます。',
    dimensionsCalculatorWidthLabelPx: '幅(px)',
    dimensionsCalculatorHeightLabelPx: '高さ(px)',
    dimensionsCalculatorDpiLabelPx: '実効DPI',
    dimensionsCalculatorMinDpiHintPx: 'この掲載スペースには最低{{dpi}} dpiが必要です。',
    dimensionsCalculatorMinQualityWidthPx: '幅の最低品質にまだ達していません(最小 {{min}}px、推奨 {{rec}}px)。',
    dimensionsCalculatorMinQualityHeightPx: '高さの最低品質にまだ達していません(最小 {{min}}px、推奨 {{rec}}px)。',
    qualityWarnLowRes: '解像度が低い - 印刷品質が低下する可能性があります',
    qualityConfirmHintLowRes: '画像は品質が低下した状態で印刷される可能性があります。',
    qualityDetailWarnPx: '{{pixelW}} × {{pixelH}} px で実寸 {{dpi}} DPI になります。',
    qualityDetailFailPx: '{{pixelW}} × {{pixelH}} px は {{outdoorW}} × {{outdoorH}} m で {{dpi}} DPI となり、最低 {{minDpi}} DPI を下回ります。',
    qualityTargetWarnPx: 'このフォーマットには少なくとも {{recDpi}} DPI を推奨します: {{recW}} × {{recH}} px、または {{recScaleLabel}}。',
    qualityTargetFailPx: '少なくとも {{minW}} × {{minH}} px が必要です - 1:{{scale}} で作業すると、{{designDpi}} DPI の {{canvasW}} × {{canvasH}} m のキャンバスになります。',
    creativeUnitLabel: 'サイズの単位',
    creativeUnitCm: 'センチメートル',
    creativeUnitPx: 'ピクセル',
    creativeUnitHint: '推奨クリエイティブサイズの表示とチェック方法を選択します。センチメートル: 掲載スペースの1:10スケールで、常に300 dpiでデザインします。ピクセル: 掲載スペースのサイズに基づく最低解像度です。',
    previewBadge: 'プレビュー',
    previewOnlyHint: 'プレビューのみ - 印刷には元ファイルをダウンロードしてください',
    downloadPrintFile: '印刷用ファイルをダウンロード',
    downloadPrintFileHint: 'フル解像度の元ファイル',
    printFileExplainer: '上の画像は軽量なプレビューです。印刷に回すには、フル解像度の元ファイルをダウンロードしてください。',
    previewFailed: 'ブラウザでこのファイルのプレビューを作成できませんでした。JPGまたはPNGで書き出して、もう一度お試しください。',
    creativeFileRequirements: '入稿可能なファイル: TIF、TIFF、JPG、JPEG、PNG、PDF。印刷にはCMYKカラーモードが必要です。その他のカラーモードの画像はCMYKに変換され、アップロード前にプレビューで確認・承認できます。PDFファイルは入稿時点でCMYKである必要があります。',
    creativeFormatNotAllowed: '「{{name}}」は対応していないファイル形式です。TIF、TIFF、JPG、JPEG、PNG、PDFのいずれかをアップロードしてください。',
    creativeNotCmykPdf: '「{{name}}」にはRGBカラー(アートワークまたは埋め込み画像)が含まれています。印刷用ファイルはすべてCMYKである必要があります。CMYKカラープロファイル(例: PDF/X-1a)で書き出し直して、アップロードしてください。',
    creativeUnreadable: '「{{name}}」を読み込めませんでした。ファイルが破損しているか、特殊な形式で保存されている可能性があります。書き出し直して、もう一度お試しください。',
    cmykNoticeTitle: '「{{name}}」はCMYKカラーモードではありません',
    cmykNoticeBody: '印刷にはCMYKが必要です。屋外広告印刷の標準プロファイルで変換でき、アップロード前に変換前後のプレビューを確認できます。',
    cmykConvert: 'CMYKに変換',
    cmykModalTitle: '印刷用にCMYKへ変換',
    cmykConverting: 'CMYKに変換中({{profile}})…',
    cmykBefore: '元の画像',
    cmykAfter: '印刷プレビュー(CMYK)',
    cmykShiftWarning: '一部の鮮やかな色は、印刷すると見た目が大きく変わります(画像の約{{percent}}%)。正確な色が重要な場合は、アップロード前にデザインソフトで調整してください。',
    cmykProfileNote: '屋外広告印刷の標準である{{profile}}プロファイルで変換しています。画面ではCMYKを正確に表示できないため、プレビューは印刷結果をシミュレーションしたものです。',
    cmykAccept: '変換したCMYK版を採用',
    cmykErrorUnavailable: 'CMYK変換は現在ご利用いただけません。デザインソフトでCMYKに変換してから、もう一度アップロードしてください。',
    cmykErrorTooLarge: 'この画像はブラウザで変換するには大きすぎます。デザインソフトでCMYKに変換してから、もう一度アップロードしてください。',
    cmykErrorFailed: 'このファイルを変換できませんでした。デザインソフトでCMYKに変換してから、もう一度アップロードしてください。',
    pay: '確認して支払う',
    commission: 'プラットフォーム手数料 ({{rate}}%)',
    vatLabel: '消費税',
    vatWithRate: '消費税 ({{rate}}%)',
    vatDetailsTitle: '消費税の詳細',
    vatDetailsBody: '消費税は、キャンペーンの各構成要素に適用される税務上の取り扱いに従って計算されます。項目によっては、消費税が含まれる場合、異なる税率が適用される場合、または課税対象外となる場合があります。',
    totalWithoutVat: '合計（税抜）',
    grandTotal: '合計',
    dailyRateRoundingNote: '日次料金はセント単位で四捨五入されます。',
    platformFeeNote: '* 屋外広告の日次料金には、5%のプラットフォーム手数料が既に含まれています。',
    confirmPayment: '支払いを確認',
    paymentSuccess: 'お支払いが完了しました！キャンペーンはまもなく有効化されます。',
    checkingPayment: '支払いを確認中…',
    paymentConfirmed: '支払い確認済み！',
    paymentConfirmedDesc: 'お支払いが確認されました。キャンペーンはまもなく有効化されます。',
    paymentPending: '支払い未確認',
    paymentPendingDesc: '現時点でお支払いを確認できませんでした。再度お試しいただくか、サポートにお問い合わせください。',
    backToCampaign: 'キャンペーンに戻る',
    expandPricing: '価格詳細を表示',
    collapsePricing: '価格詳細を非表示',
    availabilityUpdated: '1つ以上の屋外広告スペースがキャンペーンから削除されました。他のキャンペーンによって重複する日程で予約されたか、最低予告期間がすでに経過していたためです。下記の更新された選択内容をご確認ください。',
    availabilityDialogTitle: '空き状況を確認して支払いへ進む',
    availabilityDialogBody: '続行する前に、選択したすべての屋外広告が引き続き利用可能か確認します。その間に他のキャンペーンによって予約された可能性があります。競合が発生した場合の対処方法をお選びください。',
    availabilityRemoveYes: 'はい - 利用不可の屋外広告を自動的に削除する',
    availabilityRemoveYesDesc: '利用できなくなった屋外広告はこのキャンペーンから削除されます。支払い前に更新された選択内容を確認できます。',
    availabilityRemoveNo: 'いいえ - 競合をフラグして手動で確認する',
    availabilityRemoveNoDesc: '競合する屋外広告がハイライト表示されるので、日程を調整するか手動で削除してから支払いに進めます。',
    availabilityDialogConfirm: '支払いへ進む',
    outdoorFlaggedTitle: '日程が利用不可',
    outdoorFlaggedDesc: 'この屋外広告は重複する日程で他のキャンペーンに予約されました。日程を編集するか削除して続行してください。',
    outdatedOutdoorsTitle: 'キャンペーンを続行できません - 期限切れの掲載枠が検出されました',
    outdatedOutdoorsDesc: '1件以上のキャンペーン掲載枠の開始日が過去の日付になっています。お支払いは処理されていません。ハイライトされた掲載枠を確認し、開始日を更新してから再試行してください。',
    outdoorOutdatedTitle: '開始日が過去になっています',
    outdoorOutdatedDesc: 'この掲載枠の予定開始日はすでに過ぎています。続行するには将来の日付に更新してください。',
    pastStartDatesToast: 'キャンペーンの期間を過去の日付にすることはできません。',
    cancelCampaign: 'キャンペーンをキャンセル',
    cancelCampaignConfirm: 'この操作でキャンペーンが完全にキャンセルされます。よろしいですか？',
    cancelCampaignYes: 'はい、キャンセルする',
    cancelCampaignAbort: 'キャンペーンを維持',
    cancelledSuccess: 'キャンペーンがキャンセルされました。',
    cancellationPolicyPending: '無料キャンセル - キャンペーンが保留中ステータスの間は料金は発生しません。',
    cancellationPolicyReady: '全てのアウトドア広告のキャンセル日がそれぞれのスペース提供者の最短通知期間より多くの日数前である場合、キャンセル料は発生しません。1つ以上のアウトドア広告が最短通知期間内に含まれる場合はキャンセル料が発生します（ポルトガル企業は消費税が加算されます）。最短通知期間内のアウトドア広告の制作費（印刷・設置など）は返金されません。',
    cancellationPolicyRunning: 'ご注意：既に進行中のキャンペーンをキャンセルした場合、キャンペーン総額の100%が没収されます。返金は一切行われません。',
    ppInvoices: '掲出会社からの請求書',
    outdoorAdj0: '素晴らしい',
    outdoorAdj1: '最高の',
    outdoorAdj2: '壮大な',
    outdoorAdj3: '華麗な',
    outdoorAdj4: '卓越した',
    outdoorsCollapsedSummary: 'こちらに{{adj}}屋外広告が{{count}}件あります！',
    messages: 'メッセージ',
    noMessages: 'このキャンペーンに関して、まだ掲載事業者からのメッセージはありません。メッセージが届き次第、ここに会話が表示されます。',
    noMessagesYet: 'この会話にはまだメッセージがありません。',
    typeMessage: 'メッセージを入力…',
    instructions: '掲載事業者への指示',
    instructionsPlaceholder: '例：午前8時から午後10時のみ表示してください。',
    instructionsEmpty: 'まだ指示が追加されていません。編集をクリックして指示を追加してください。',
    instructionsSaved: '指示を保存しました。',
    proofOfDisplay: '掲出証明',
    proofPending: '証明写真準備中',
    proofPendingDesc: 'スペース提供者が掲出証明写真をまもなくアップロードします。',
    proofAlt: '掲出証明 – {{name}}',
    additionalFiles: '追加ファイル',
    additionalFilesSubtitle: 'このキャンペーンの補足資料（任意）',
    additionalFilesSubtitlePP: '広告主が共有した補足資料',
    noAdditionalFiles: '追加ファイルはまだアップロードされていません。',
    uploadFile: 'ファイルをアップロード',
    fileUploaded: 'ファイルが正常にアップロードされました。',
    fileDeleted: 'ファイルを削除しました。',
    deleteFile: 'ファイルを削除',
    addOutdoors: '屋外広告を追加',
    creativesLockedTitle: '屋外広告がまだ追加されていません',
    creativesLockedDesc: 'クリエイティブは各屋外広告の必要解像度に合わせる必要があります。アップロードを有効にするには、少なくとも1つの屋外広告を追加してください。',
    editDates: '日程を編集',
    updateDates: '日程を更新',
    datesUpdated: '日程が正常に更新されました',
  },
  dashboard: {
    title: 'ダッシュボード',
    earnings: '収益',
    spendings: '支出',
    last30: '過去30日間',
    last90: '過去90日間',
    thisYear: '今年',
    accessRequests: 'アクセスリクエスト',
    noRequests: '保留中のリクエストなし',
    approve: '承認',
    reject: '拒否',
    teamInvite: 'チームメンバーを招待',
    inviteEmail: 'メールアドレス',
    sendInvite: '招待を送信',
    totalEarned: '総収益',
    totalSpent: '総支出',
    activeOutdoors: 'アクティブな広告スペース',
    activeCampaigns: 'アクティブなキャンペーン',
    overview: '概要',
    howPaidTitle: '支払いの受け取り方',
    howPaidDesc: 'キャンペーン開始後、各広告看板の写真証明をアップロードしてください。すべての証明が確認されると、支払いが自動的に行われます。お支払い額は、掲載日額料金にキャンペーンの有効日数を乗じた金額から、予約ごとに適用される5%のプラットフォームサービス手数料を差し引いた金額となります。',
    ppOverview: 'スペースプロバイダーの概要',
    advertiserOverview: '広告主の概要',
    findOutdoors: '広告スペースを探す',
    addOutdoor: '広告スペースを追加',
    viewCampaigns: 'キャンペーンを表示',
    manageOutdoors: '広告スペースを管理',
    companyDetails: '会社詳細',
    userDetails: 'アカウント詳細',
    pendingRequests: '保留中のアクセスリクエスト ({{count}})',
    inviteDesc: 'Scapowであなたの会社に参加するためのリンクが記載されたメールが届きます。',
    invitePlaceholder: 'colleague@company.com',
    invoicesTitle: '請求書',
    downloadInvoice: 'ダウンロード',
    invoiceIssued: '発行',
    invoicePaid: '支払済',
    invoiceUnknownCampaign: '不明なキャンペーン',
    invoicesSubtitle: '支払い履歴とダウンロード可能な請求書ドキュメント。',
    invoicesEmpty: 'このセクションを充実させられる日を楽しみにしています！',
  },
  invoices: {
    title: '請求書',
    subtitleAdvertiser: 'すべてのキャンペーンに関するScapowおよび掲載プロバイダーの請求書。',
    subtitlePP: '支払い履歴とダウンロード可能な請求書。',
    issued: '発行日',
    download: 'ダウンロード',
    empty: '請求書はまだありません。キャンペーンが処理されるとここに表示されます。',
    unknownCampaign: '不明なキャンペーン',
    ppInvoices: '掲載プロバイダー請求書（{{count}}件）',
    unknownProvider: '不明なプロバイダー',
    notAvailable: '利用不可',
    typeInvoice: '請求書',
    typeCreditNote: 'クレジットノート',
  },
  payments: {
    title: '支払い',
    subtitle: 'あなたの掲載スペースで実施されたキャンペーンの支払い履歴です。',
    empty: '支払いはまだありません。キャンペーンの支払いが行われるとここに表示されます。',
    unknownCampaign: '不明なキャンペーン',
    columnId: '支払いID',
    columnCampaign: 'キャンペーン',
    columnValue: '金額',
    columnPaidAt: '支払日',
    columnStatus: 'ステータス',
    statusPaid: '支払い済み',
    statusTransferRequested: '振込申請中',
  },
  userDetails: {
    receiveEmails: 'メールを受け取る',
    receiveEmailsOnDesc: 'プラットフォームからのメールは {{email}} に送信されます。',
    receiveEmailsOffDesc: 'プラットフォームからのメールは届きません。再び受け取るにはオンにしてください。',
    emailsTurnedOn: 'プラットフォームからのメールを受け取ります。',
    emailsTurnedOff: 'プラットフォームからのメールは今後届きません。',
    emailsUpdateError: 'メールの設定を更新できませんでした。',
    title: 'アカウント詳細',
    subtitle: '個人アカウント情報を管理します。',
    name: '名前',
    editName: 'クリックして編集',
    email: 'メールアドレス',
    memberSince: '登録日 (UTC)',
    accountStatus: 'アカウントステータス',
    statusVerified: '確認済み',
    statusPending: '確認待ち',
    nameUpdated: '名前を更新しました。',
    nameRequired: '有効な名前を入力してください(2文字以上)。',
    password: 'パスワード',
    changePassword: 'パスワードを変更',
    currentPassword: '現在のパスワード',
    newPassword: '新しいパスワード',
    confirmNewPassword: '新しいパスワード(確認)',
    passwordUpdated: 'パスワードが正常に更新されました。',
    passwordFieldsRequired: 'すべてのパスワード欄を入力してください。',
    passwordTooShort: '新しいパスワードは8文字以上で入力してください。',
    passwordSameAsCurrent: '新しいパスワードは現在のパスワードと異なる必要があります。',
    passwordMismatch: '新しいパスワードと確認用パスワードが一致しません。',
  },
  admin: {
    tabUnpaidInstallments: '未払いの分割払い',
    unpaidInstallmentsIntro: '支払期日から6日経っても未払いの分割払い（古い順）。',
    noUnpaidInstallments: '未払いの分割払いはありません。',
    installmentOf: '分割払い {{number}}/{{total}}',
    installmentNumber: '分割払い {{number}}',
    installmentDue: '期日 {{date}}',
    installmentOverdueDays_one: '{{count}}日超過',
    installmentOverdueDays_other: '{{count}}日超過',
    proofOfCompany: '会社証明書類',
    openProofOfCompany: '{{name}}を新しいタブで開く',
    noProofOfCompany: '会社証明書類はアップロードされていません',
    proofLocationLoading: '住所を検索中…',
    proofLocationViewMap: '地図で見る',
    title: '管理パネル',
    verifications: '認証',
    advertisers: '広告主',
    providers: 'プロバイダー',
    payments: '支払い',
    noVerifications: '保留中の認証なし',
    noPayments: '保留中の支払いなし',
    markAsDone: '完了としてマーク',
    business: '会社',
    type: 'タイプ',
    status: 'ステータス',
    actions: 'アクション',
    approve: '承認',
    reject: '拒否',
    subtitle: 'プラットフォームの管理とモデレーション',
    proofVerification: '手動確認',
    accessRequestsTab: 'アクセスリクエスト',
    noAccessRequests: '保留中のアクセスリクエストはありません。',
    noAdvertisers: '広告主が見つかりません。',
    noProviders: 'プロバイダーが見つかりません。',
    noPaymentsStatus: 'このステータスの支払いはありません。',
    campaignOutdoor: 'キャンペーン広告スペース: {{id}}',
    campaignFrom: '{{date}}のキャンペーン',
    adCreative: '広告クリエイティブ',
    proofPhotos: '証明写真 ({{count}}) - クリックしてフルサイズで開く',
    period: '期間',
    outdoorsLabel: '件の広告スペース',
    campaignsLabel: '件のキャンペーン',
    spentLabel: '支出',
    earnedLabel: '収入',
    markAsPaid: '支払済みとしてマーク',
    tabAds: '広告',
    tabBusinessProofs: '企業証明書',
    tabProofOfAds: '広告証明書',
    approved: '承認済み',
    rejected: '却下済み',
    noAds: '保留中の広告確認はありません。',
    noBusinessProofs: '保留中の企業証明書はありません。',
    noProofOfAds: '保留中の広告証明書はありません。',
    refundsTab: '返金・負債',
    refundsSearchPlaceholder: 'キャンペーン名または広告主名で検索…',
    refundsNoCampaigns: 'キャンペーンが見つかりません。',
    refundsSelectOutdoors: '返金する屋外広告を選択',
    refundsSelectAll: 'すべて選択',
    refundsDeselectAll: 'すべて解除',
    refundsNoEligible: 'このキャンペーンに対象となる屋外広告が見つかりません。',
    refundsEligibleNote: '拒否されていない屋外広告のみが返金対象となります。',
    refundsSubmit: '返金を処理する',
    refundsSuccess: '返金が正常に処理されました。',
    refundsSubTabRefunds: '広告主への返金',
    refundsSubTabDebts: 'プロバイダーの負債',
    refundTypeTotal: '全額',
    refundTypePartial: '一部',
    refundDaysLabel: '返金対象日数',
    refundDaysHint: '最大{{max}}日',
    debtNoDebts: '未払いのプロバイダー負債はありません。',
    debtSettle: '精算',
    debtSettleAmount: '精算金額',
    debtSettleDoc: '精算書類',
    debtSettleDocHint: '署名済みの精算書類をアップロードしてください（PDF、画像など）',
    debtSettleConfirm: 'アップロードして精算',
    debtSettleSuccess: '負債が精算され、書類が正常にアップロードされました。',
    debtStatusOutstanding: '未払い',
    debtStatusSettled: '精算済み',
    debtCampaign: 'キャンペーン',
    campaignsTab: 'キャンペーン',
    noCampaigns: 'キャンペーンが見つかりません。',
    accessRequestFor: 'アクセスをリクエスト：{{entity}}',
    tabByStatus: 'ステータス別',
    tabTransferRequested: '振込申請',
    checkPayment: '確認',
    lastCheckedAt: '最終確認',
    neverChecked: '未確認',
    noTransferRequested: '振込申請済みの支払いが見つかりません。',
    checkSuccess: '支払い確認を開始しました。',
    revenueTitle: '収益',
    revenueSubtitle: '請求期間ごとのプラットフォーム手数料・消費税',
    revenueGross: '総収益',
    revenueCommission: '手数料',
    revenueVat: '消費税',
    revenueStripeFees: 'Stripe手数料',
    revenueNet: '純収益',
    revenueEmpty: 'この期間の収益データがありません。',
    revenueMonth: '月',
    revenueYear: '年',
    revenueDailyTitle: '日次内訳',
    revenueNoDaily: 'この期間の日次データがありません。',
    searchByName: '名前で検索…',
    importOutdoorsFromFile: 'ファイルからアウトドアをインポート',
    chooseFile: 'ファイルを選択…',
    csvSend: '送信',
    importOutdoorsSuccess: 'アウトドアファイルが正常に送信されました。',
    remainingFreeCommissions: '残りの手数料無料回数: {{count}}',
    setFreeCommissions: '残りの手数料無料回数を新たに設定',
    freeCommissionsUpdated: '残りの手数料無料回数を更新しました。',
    freeCommissionsUpdateFailed: '残りの手数料無料回数を更新できませんでした。',
    verified: '認証済み',
  },
  ppCampaigns: {
    searchAllStatuses: 'すべてのステータスのキャンペーンを表示しています。ステータスで絞り込むには検索をクリアしてください。',
    typeAll: 'すべて',
    typeScapow: 'Scapow',
    typeOffline: 'オフライン',
    typeFilterLabel: 'キャンペーンの種類',
    noOfflineResults: 'オフラインキャンペーンはまだありません。アウトドアページから追加できます。',
    goToOutdoors: 'アウトドアへ',
    offlineBadge: 'オフライン',
    moreOutdoors: 'ほか{{count}}件',
    offlineNotes: 'メモ',
    payoutCommission: 'プラットフォーム手数料',
    payoutCommissionVat: 'プラットフォーム手数料の消費税',
    payoutTransferred: '振込額',
    payoutValueWithoutVat: '広告料（税抜）',
    payoutVat: '消費税',
    payoutProduction: '制作費（税込）',
    payoutsTitle: '受取',
    payoutsCount: '受取回数：{{count}}',
    payoutsReceived: 'これまでの受取額',
    payoutFull: '一括受取',
    payoutFirst: '初回受取 · {{month}}',
    payoutAfterProof: '{{date}}以降、掲出証明の承認後に支払予定',
    payoutExpectedOn: '{{date}}に支払予定',
    payoutReceivedOn: '{{date}}に受取済み',
    payoutProcessing: '振込処理中',
    payoutOnHold: '保留中 - 広告主の口座振替が失敗しました',
    payoutsOnHoldNotice: '広告主の口座振替が失敗したため、受取が保留されています。その支払いが完了次第、支払われます。',
    payoutsNetNote: '金額はScapow手数料およびその消費税を差し引いた額で、未払いの債務控除前です。',
    colProduction: '制作',
    title: 'キャンペーン',
    subtitle: 'あなたの屋外広告スペースを含むキャンペーンを監視・管理します。',
    tabPending: '保留中',
    tabReady: '準備完了',
    tabRunning: '実行中',
    tabCompleted: '完了',
    noResults: 'このステータスのキャンペーンが見つかりません。',
    outdoorSlots: '{{count}}件の屋外広告枠',
    outdoorSlots_plural: '{{count}}件の屋外広告枠',
    instructions: '広告主の指示',
    backToCampaigns: 'キャンペーン一覧に戻る',
    yourSlots: 'あなたの屋外広告枠',
    noSlots: 'このキャンペーンにあなたの掲載スペースの広告枠が見つかりません。',
    advertiserInstructions: '広告主からの指示',
    messagesWithAdvertiser: '広告主とのメッセージ',
    noConversation: 'まだメッセージはありません。以下に入力して広告主との会話を始めましょう。',
    myInvoice: '広告主への請求書',
    uploadInvoice: '請求書をアップロード',
    replaceInvoice: '請求書を差し替え',
    uploadInvoiceSuccess: '請求書が正常にアップロードされました。',
    invoiceUploaded: '請求書を表示',
    noInvoiceYet: 'まだ請求書がアップロードされていません。',
    creativesAndOutdoors: 'クリエイティブとあなたの屋外広告',
    noCreativeForRatio: 'このフォーマットのクリエイティブはまだアップロードされていません。',
    yourOutdoorsForFormat: 'このフォーマットのあなたの屋外広告',
    viewOutdoor: '屋外広告を見る',
    goToCampaign: 'キャンペーンページへ',
    yourEarnings: 'あなたの収益',
    readyPaymentTitle: '掲出確認が必要です',
    readyPaymentNoteReady: '収益はキャンペーン開始待ちの状態で確保されています。キャンペーンが開始したら、各屋外広告の設置証明をアップロードして支払いを開始してください。',
    readyPaymentNote: '収益を受け取るには、「掲出確認」ステップで各屋外広告の設置証明をアップロードしてください。',
    readyPaymentCta: '掲出確認へ進む',
    paymentPaidTitle: '支払い完了',
    paymentPaidDesc: 'このキャンペーンの収益はお支払い済みです。',
    viewBreakdown: '内訳を見る',
    earningsBreakdown: '収益の内訳',
    colDays: '日数',
    colNetDailyValue: '日次単価 + 消費税',
    colEarnings: '収益',
  },
  upcomingCampaigns: {
    title: '近日のキャンペーン',
    subtitle: 'あなたの屋外スペースを含む、間もなく開始されるキャンペーン。',
    noResults: '近日のキャンペーンは見つかりませんでした。',
  },
  getPaid: {
    title: '支払いを受ける',
    subtitle: '以下の手順に従って掲載を確認し、支払いを受け取ってください。',
    step1: { label: '近日のキャンペーン', desc: 'クリエイティブを入手して屋外広告を設置しよう' },
    step2: { label: '掲載の確認', desc: '広告証明をアップロードして報酬を受け取る' },
    step3: { label: '支払済み請求書', desc: 'お支払い履歴' },
    paidOn: '支払日',
    downloadInvoice: '請求書',
    noPayments: 'まだ支払いがありません',
    noPaymentsDesc: '確認ステップを完了して支払いを解除してください。',
    upcomingEmpty: '現在、近日のキャンペーンはありません。後でご確認ください。',
    goToVerify: '掲載の確認へ',
    goToPaid: '支払いを見る',
    goToUpcoming: '近日のキャンペーンを見る',
  },
  cart: {
    title: 'カート',
    empty: 'カートは空です',
    emptyDesc: '広告スペースを検索してカートに追加し、キャンペーンを作成してください。',
    browseOutdoors: '屋外広告を見る',
    campaignDetails: 'キャンペーン詳細',
    campaignName: 'キャンペーン名',
    description: '説明（任意）',
    subtotal: '小計',
    total: '合計',
    remove: '削除',
    placeOrder: 'キャンペーンを作成する',
    creating: '作成中…',
    estimatedCost: '見積もり費用',
    signInTitle: 'ログインして続ける',
    signInDesc: 'アカウントを作成するかログインしてキャンペーンを作成してください。',
    buildCampaign: 'キャンペーンを作成',
    estimatedTotal: '推定合計',
    campaignNamePlaceholder: '2026年夏キャンペーン',
    detailsPlaceholder: 'メモがあれば...',
    campaignLabel: 'キャンペーン {{n}}',
    selectCampaign: 'キャンペーンに追加:',
    signInToCheckout: 'このキャンペーンを作成するにはサインインしてください',
    advertiserRequired: 'キャンペーンを作成するには広告主アカウントが必要です',
    instructions: '掲載事業者への指示（任意）',
    instructionsPlaceholder: '掲載事業者への特別な指示はこちらにご記入ください...',
    instructionsHint: 'キャンペーン作成後にこのフィールドを更新できます。',
  },
  invitations: {
    title: 'ユーザー招待',
    subtitle: 'ビジネスのチームメンバー招待を管理する',
    pendingTitle: '保留中の招待',
    noPending: '保留中の招待はありません',
    noPendingDesc: '上記でチームメンバーを招待して開始してください。',
    sentAt: '送信日',
    cancel: 'キャンセル',
    inviteSuccess: '招待が正常に送信されました。',
    inviteError: '招待の送信に失敗しました。',
    cancelSuccess: '招待がキャンセルされました。',
    formTitle: 'チームメンバーを招待',
    formDesc: 'Scapowであなたの会社に参加するためのリンクが記載されたメールが届きます。',
    formPlaceholder: 'colleague@company.com',
    formSend: '招待を送信',
  },
  terms: {
    back: '戻る',
    title: '利用規約',
    effectiveDate: '発効日：2026年6月19日 · SCAPOW · Codify, Unipessoal Lda',
    introBanner: 'アカウントを登録し、プラットフォームにアクセスまたは利用することにより、これらの規約に法的に拘束されることに同意したものとみなされます。同意されない場合は、プラットフォームをご利用いただけません。',
    footerNote: 'SCAPOW · Codify, Unipessoal Lda · 2026年6月19日発効',
    s1: '序文',
    s1_p1: '本利用規約（以下「規約」）は、Codify, Unipessoal Lda（以下「当社」「私たち」「私たちの」）が運営するSCAPOWプラットフォーム（以下「プラットフォーム」）へのアクセスおよび利用を規律します。',
    s1_p2: 'プラットフォームは、以下の当事者をつなぐデジタルマーケットプレイスとして機能します：',
    s1_i1Bold: '広告主',
    s1_i1Rest: '：マーケティングキャンペーン用の広告スペースを購入しようとする方；および',
    s1_i2Bold: 'スペース提供者',
    s1_i2Rest: '：看板、屋外サイン、デジタルディスプレイ、その他の媒体掲載物を含む物理的な広告スペースを所有・運営・管理する方。',
    s2: '利用資格',
    s2_p1: 'ユーザーは以下の要件を満たす必要があります：',
    s2_i1: '18歳以上であること；',
    s2_i2: '法的拘束力のある契約を締結する法的能力を有すること；',
    s2_i3: '登録時に正確かつ完全な情報を提供すること；',
    s2_i4: 'すべての適用法令および規制を遵守すること。',
    s2_p2: '法人ユーザーは、自社または組織を代表する権限を有することを表明します。',
    s3: 'ユーザーの役割',
    s3_1: '3.1 広告主',
    s3_1_p1: '広告主は以下のことができます：',
    s3_1_i1: '広告スペースを検索・選択・購入する；',
    s3_1_i2: '広告素材をアップロードする；',
    s3_1_i3: 'キャンペーンを開始・管理する。',
    s3_1_p2: '広告主は以下について単独で責任を負います：',
    s3_1_i4: '広告コンテンツの合法性；',
    s3_1_i5: '使用するすべての知的財産の所有権または使用許可；',
    s3_1_i6: '広告に関する法令の遵守。',
    s3_2: '3.2 スペース提供者',
    s3_2_p1: 'スペース提供者は以下のことができます：',
    s3_2_i1: '利用可能な広告スペースを掲載する；',
    s3_2_i2: '価格、キャンペーン利用可能日、運用要件を設定する；',
    s3_2_i3: 'キャンペーンの掲載を承認する。',
    s3_2_p2: 'スペース提供者は以下を表明・保証します：',
    s3_2_i4: '広告スペースを所有または合法的に管理していること；',
    s3_2_i5: '商業広告利用に必要なすべての許可、ライセンス、権利を有すること；',
    s3_2_i6: '合意した期間内に予約済みキャンペーンを履行できること。',
    s3_3: '3.3 広告スペース掲載に関する法的宣言',
    s3_3_p1: 'プラットフォームに屋外広告スペースを掲載する際、各スペース提供者は申請時に以下を明示的に確認する必要があります：',
    s3_3_i1: '申請した広告スペースに対する法的権利を保有していること；',
    s3_3_i2: '商業目的での提供が許可されていること；',
    s3_3_i3: '掲載がすべての適用法令、許可、ライセンス、ゾーニング規制、および地方自治体の要件に準拠していること。',
    s3_3_p2: 'この宣言は掲載の条件です。確認なしの申請は受理されません。プラットフォームは、宣言が虚偽または誤解を招くと判明した場合、掲載を削除する権利を有し、不正確な情報を提供したスペース提供者のアカウントを停止または解約する権利を有します。',
    s4: 'プラットフォームの役割',
    s4_p1: 'プラットフォームは仲介者・促進者としてのみ機能します。当社は：',
    s4_i1: '広告スペースを所有しない；',
    s4_i2: '広告主またはスペース提供者として行動しない；',
    s4_i3: 'キャンペーンのパフォーマンス、インプレッション、または事業成果を保証しない；',
    s4_i4: '広告の物理的な設置または撤去について責任を負わない。',
    s4_p2: '各取引は、広告主とスペース提供者の間に直接的な契約関係を形成します。',
    s5: 'キャンペーン予約',
    s5_p1: 'キャンペーン予約は以下の条件が揃った時点で拘束力を持ちます：',
    s5_i1: '広告主が決済を完了していること - 全額を支払うか、分割払いのキャンペーンについては初回支払いと以降の分割金の口座振替を承認していること；',
    s5_i2: '各屋外広告枠が確定していること - 即時予約の枠は直ちに、それ以外は確認期間内に掲載提供者により確定されます；',
    s5_i3: 'キャンペーン開始日が設定された。',
    s5_p2: 'すべての予約は、スペース提供者が定める最小運用通知期間に従います。この期間は、広告主がキャンペーンを申請・支払いできる最終期限を決定します。この期間を満たさない場合、拒否または再スケジュールとなる場合があります。',
    s6: '支払い条件',
    s6_1: '6.1 広告主の支払い',
    s6_1_p1: '広告主は、決済時に選択した支払プランに従って支払います：',
    s6_1_i1: '一括払い - キャンペーン総額が決済時に請求されます；',
    s6_1_i2: '月払いまたは3か月ごと - 制作費と最初の請求期間分が決済時に請求され、以降の各請求期間分はその初日に口座振替で引き落とされます。これらのプランは、キャンペーンが最初の請求期間を超える場合にのみ利用できます。',
    s6_1_p2: '決済は、キャンペーン開始日より前、かつ掲載提供者の最短通知期間の満了前に完了しなければなりません。屋外広告枠に確認が必要な場合、決済時には支払いの与信のみが行われ、確定後に確定した枠についてのみ請求されます。分割金の支払遅延については第6.4条が適用されます。決済が期限内に完了しない場合：',
    s6_1_i3: '予約が自動的にキャンセルされる場合があります；',
    s6_1_i4: 'スペース提供者は広告スペースを確保する義務を負いません。',
    s6_2: '6.2 プラットフォーム手数料',
    s6_2_p1: 'プラットフォームはサービス手数料、コミッション、または取引手数料を請求する場合があります。これらの手数料は購入前に開示されます。プラットフォーム手数料は、法律で要求される場合を除き、返金されません。',
    s6_3: '6.3 スペース提供者への支払い',
    s6_3_p1: 'スペース提供者は以下の条件を満たした後にのみ支払いを受ける資格を得ます：',
    s6_3_i1: '広告素材が完全に設置された；',
    s6_3_i2: '設置証明がプラットフォームを通じてアップロードされた；',
    s6_3_i3: '証明が承認されるか、適用レビュー期間内に異議申し立てがない。',
    s6_3_p2: '証明には、キャンペーンが正しく表示されていることを示す明確な写真証拠が含まれる必要があります。プラットフォームは真正性を確認する権利を有します。不正行為、紛争、または不履行の場合、支払いが遅延、保留、または取り消される場合があります。',
    s6_4: '6.4 支払義務および支払遅延',
    s6_4_p1: '確定した各予約は、広告主の拘束力ある支払義務を構成します。広告主は、予約したキャンペーンおよび屋外広告枠に係るすべての金額を、分割払い（毎月または3か月ごと）のキャンペーンの各分割金を含め、期日までに全額支払わなければなりません。',
    s6_4_i1: '期日までに支払われなかった金額（拒否、返却または取消された口座振替を含みます）は、当該期日から延滞となります。プラットフォームは広告主に通知し、再度の回収を試みることがあります。',
    s6_4_i2: 'キャンペーンに関するいずれかの金額が期日から2か月を超えて延滞した場合、掲載提供者は、広告主に対して責任を負うことなく、該当する屋外広告枠から広告主のクリエイティブを撤去し、当該枠を他の広告主に提供することができます。',
    s6_4_i3: 'かかる撤去によって広告主の義務が免除されることはなく、既に期日の到来したすべての金額および第9.3条に基づき適用される手数料は、引き続き全額支払義務を負います。',
    s6_4_i4: 'プラットフォームおよび／または掲載提供者は、適用法で認められる範囲において、未払金に加え、適用される法定利率による遅延損害金ならびに合理的な回収費用および法的費用の回収のため、法的措置を講じることができます。',
    s6_4_i5: 'プラットフォームはまた、第15条に従い、すべての延滞金額が清算されるまで、広告主のアカウントを停止し、新規予約を拒否することができます。',
    s6_4_p2: '本条に基づくクリエイティブの撤去は、第9.4条および第9.5条に定める掲載提供者の不履行には該当せず、いかなる返金も生じません。',
    s7: 'キャンペーン素材',
    s7_p1: '広告主は必要な期限内にキャンペーン素材を提出する必要があります。素材は以下の要件を満たす必要があります：',
    s7_i1: '技術仕様を満たすこと；',
    s7_i2: '印刷可能かつ使用可能であること；',
    s7_i3: '適用法令に準拠すること；',
    s7_i4: '違法、名誉毀損、攻撃的、または権利侵害のコンテンツを含まないこと。',
    s7_p2: 'スペース提供者は不適合な素材を拒否することができます。プラットフォームは独自の判断でコンテンツを削除する場合があります。',
    s8: '設置証明',
    s8_p1: 'スペース提供者は設置後速やかに設置証明をアップロードする必要があります。証明の未提供は以下につながる場合があります：',
    s8_i1: '支払いの遅延；',
    s8_i2: '支払いのキャンセル；',
    s8_i3: 'プラットフォームからの停止。',
    s8_p2: '広告主はアップロード後、適用の異議申立期間内に証明に異議を申し立てることができます。この期間内に異議申し立てがない場合、証明は承認されたとみなされます。',
    s9: 'キャンセルと返金',
    s9_1: '9.1 広告主によるキャンセル',
    s9_1_p1: '広告主がキャンセルする場合：',
    s9_1_i1: 'スペース提供者の最小通知期間前：適用手数料を差し引いた返金の対象；',
    s9_1_i2: '通知期間開始後：返金が拒否される場合があります。',
    s9_1_p2: '製作、印刷、準備にかかる費用は返金されない場合があります。',
    s9_2: '9.2 スペース提供者によるキャンセル',
    s9_2_p1: 'スペース提供者が正当な理由なく確定予約をキャンセルした場合：',
    s9_2_i1: '広告主は全額返金を受けます；',
    s9_2_i2: 'スペース提供者はペナルティ、可視性の低下、停止、またはアカウント解約を受ける場合があります。',
    s9_3: '9.3 キャンペーンキャンセルポリシー',
    s9_3_i1: '保留中ステータスのキャンペーンは、支払い前であればいつでも無料でキャンセルできます。',
    s9_3_i5: 'キャンセル日が各アウトドア広告の開始日より、それぞれのスペース提供者が定める最短通知期間を超える日数前である場合、キャンセル料は発生せず、広告主は支払い済みの全額の返金を受けます。',
    s9_3_i2: '支払い完了後、キャンペーン内の1つ以上のアウトドア広告の起動日が、それぞれのスペース提供者が定める最短通知期間内に含まれる場合、キャンペーン総額の30%のキャンセル料が発生します。',
    s9_3_i3: 'ポルトガルに登録された企業の場合、キャンセル料に適用消費税率が加算されます。',
    s9_3_i4: '1つ以上のアウトドア広告の起動日がスペース提供者の定める最短通知期間内に含まれる場合、セットアップおよび印刷費用は返金されません。',
    s9_3_i6: '既に進行中のキャンペーンをキャンセルした場合、キャンペーン総額の100%が没収されます。返金は一切行われません。',
    s9_3_i7: '30%のキャンセル料が適用される場合、キャンペーン総額の20%が該当するスペース提供者に支払われます。ただし、プラットフォームの標準手数料5%および適用消費税を差し引いた金額となります。',
    s9_4: '9.4 未証明の掲載に対する返金',
    s9_4_p1: 'スペース提供者が必要な期間内に1つ以上の屋外広告掲載について有効な掲出証明を提出しなかった場合、Scapowは以下の通り広告主に返金を行います：',
    s9_4_i1: 'キャンペーン期間中、掲載枠が広告主のクリエイティブを掲出できなかった日ごとに、当該掲載枠の日割り相当額が広告主へ返金されます。',
    s9_4_i4: '未掲出日について返金される合計金額に対して10%のキャンセル料が適用され、さらに適用される消費税が加算されます。',
    s9_4_i2: '返金は、掲出証明が提供されていないか無効とみなされたことが確認されてから合理的な期間内に処理されます。',
    s9_4_i3: '証明済みかつ履行済みの掲載に適用されるプラットフォームサービス手数料は返金対象外となります。',
    s9_5: '9.5 掲載プロバイダーの不履行 - キャンペーンの部分的な履行',
    s9_5_p1: '掲載プロバイダーが、合意されたキャンペーン期間の全期間にわたって広告主の広告素材を表示しなかった場合、合意された表示義務が履行されなかった各日を「不履行日」といいます。',
    s9_5_a: 'a) Scapowに対する金銭的責任',
    s9_5_p2: '各不履行日につき、掲載プロバイダーは、当該キャンペーン枠に適用される日次広告価値レートに相当する金額（「不履行額」）をプラットフォームに対して責任を負います。不履行額の回収は、プラットフォームの単独の裁量により、以下の1つまたは複数の方法によって行われます：',
    s9_5_i1: '(i) プラットフォームが発行する書面による通知に記載された期間内に、掲載プロバイダーが不履行額を直接プラットフォームに送金することを要求する方法；または',
    s9_5_i2: '(ii) 同一キャンペーンまたはプラットフォームにおける以降の取引のいずれかを問わず、掲載プロバイダーに支払われるべき現在または将来のキャンペーン支払いから不履行額を控除する方法。',
    s9_5_p3: 'プラットフォームは、不履行額合計を全額回収するために必要な範囲で、両方の救済手段を同時に適用する権利を留保します。',
    s9_5_b: 'b) 広告主への全額返金',
    s9_5_p4: '各不履行日につき、広告主は、当該日に支払われたすべての金額の全額返金を受ける権利を有します。これには、対応する日次キャンペーンレート、適用されるプラットフォーム手数料、および当該日に帰属するサービス手数料または取引手数料が含まれます。当該返金は、不履行の確認後、合理的な期間内にプラットフォームによって処理されます。',
    s9_5_c: 'c) 不履行の判断',
    s9_5_p5: '合意された表示期間の不履行は、プラットフォームを通じて提出された証拠に基づいて評価されます。これには、掲載証明記録、広告主の報告書、写真による文書、およびプラットフォームが関連性があると判断するその他の資料が含まれますが、これらに限りません。プラットフォームの判断は、不履行額の計算および広告主への返金管理の目的において最終的かつ拘束力を持ち、適用法の下での両当事者の法的権利を損なうものではありません。',
    s9_6: '9.6 不可抗力 - 自然災害',
    s9_6_p1: '「不可抗力事由」とは、広告主および掲載提供者の合理的な管理を超える自然災害またはこれに関連する緊急事態であって、屋外広告枠が広告主のクリエイティブを掲出することを物理的に妨げ、または掲出を危険にするものをいい、地震、洪水、暴風雨、台風・ハリケーン、山火事、土砂崩れ、所轄官庁が発令する避難命令または緊急命令、およびこれらの事由による停電を含みます。通常の悪天候、通常の損耗および保守の不備は不可抗力事由に該当しません。',
    s9_6_a: 'a) 通知および証拠',
    s9_6_p2: '掲載提供者は、不可抗力事由を知った時から48時間以内に、証拠（写真や公的な警報など）および復旧予定日を添えて、プラットフォームを通じて報告しなければなりません。プラットフォームは当該証拠に基づき事由の該当性を判断し、その判断は本条の適用上、最終的かつ拘束力を有するものとします。',
    s9_6_b: 'b) 掲載提供者への効果',
    s9_6_i1: '該当する不可抗力事由により掲出が妨げられた各日（「不可抗力日」）は、第9.5条に定める不履行日には該当せず、当該日について不履行金は発生しません。',
    s9_6_i2: '不可抗力日について、掲載提供者への支払いは行われません。',
    s9_6_i3: '掲載提供者は、不可抗力事由の終了後5営業日以内に掲出を復旧しなければなりません。当該期間を経過しても掲出が復旧されない日は、第9.5条に定める不履行日とします。',
    s9_6_i4: '掲載提供者は、その構造物の保守および適切な保険について引き続き責任を負い、当該事由により損傷または滅失したクリエイティブ素材の再印刷および再設置の費用も負担します。',
    s9_6_c: 'c) 広告主への効果',
    s9_6_i5: '広告主は、不可抗力日について支払ったすべての金額（日額キャンペーン料金、対応するプラットフォーム手数料および適用される付加価値税を含む）の全額返金を、第9.4条に定める10%の手数料なしで受ける権利を有します。',
    s9_6_i6: '広告主は、返金に代えて、屋外広告枠の空き状況に応じて、影響を受けた日数をキャンペーンの最後に移すことを選択できます。',
    s9_6_i7: '掲出開始前に不可抗力事由により屋外広告枠が利用できなくなった場合、第9.3条にかかわらず、広告主または掲載提供者はキャンセル料なしでこれをキャンペーンから除外でき、広告主は当該枠について支払った金額の全額返金を受けます。',
    s9_6_i8: '不可抗力事由が14日を超えて、または影響を受けた枠の残りのキャンペーン期間の半分を超えて継続する場合、広告主は当該枠の残りを無償でキャンセルし、残りの日数分の返金を受けることができます。',
    s9_6_i9: '月払いのキャンペーンについては、将来の分割払いがこれに応じて減額または取り消されます。',
    s9_6_d: 'd) 適用範囲',
    s9_6_p3: '屋外広告枠ではなく広告主自身の事業のみに影響する事由は本条の対象外とし、第9.3条のキャンペーンキャンセルポリシーが適用されます。',
    s9_7: '9.7 破壊行為',
    s9_7_p1: '「破壊行為」とは、広告主および掲載提供者と無関係の第三者による、屋外広告枠または広告主のクリエイティブの故意の損壊、汚損または撤去をいい、例えば落書き、破られたり覆われたりしたポスター、損傷した画面や構造物などを含みます。',
    s9_7_i1: '掲載提供者は、破壊行為を知った時から48時間以内に、写真および可能な場合は警察への届出の記録を添えて、プラットフォームを通じて報告しなければなりません。',
    s9_7_i2: '掲載提供者は、報告から3営業日以内に、自己の費用で、クリエイティブの再印刷および再設置を含めて掲出を復旧しなければなりません。',
    s9_7_i3: '当該復旧期間内に掲出が妨げられた日は、第9.6条に定める不可抗力日として扱われ、広告主は手数料なしで全額返金を受ける権利を有し、不履行金は発生しません。',
    s9_7_i4: '復旧期間を経過した日、または掲載提供者が合理的な予防措置を講じなかったことに起因する破壊行為については、第9.5条に定める不履行日とします。',
    s9_7_i5: '同一の屋外広告枠が30日以内に3回以上破壊行為を受けた場合、掲載提供者は合理的な予防措置を講じなければならず、広告主は当該枠の残りを無償でキャンセルし、残りの日数分の返金を受けることができます。',
    s9_7_p2: '発生していない不可抗力事由または破壊行為を報告することは、第12条に定める虚偽の掲出証明の提出とみなされ、アカウントの即時停止または解約の対象となる場合があります。',
    proofProtectionNote: 'お客様の投資は保護されています：屋外掲載のいずれかが掲出の証明を提供できなかった場合、Scapowはその掲載に対応する金額を返金いたします。',
    s10: '紛争',
    s10_p1: 'ユーザーはまずプラットフォームを通じた解決を試みることに同意します。プラットフォームは：',
    s10_i1: 'キャンペーンの証拠を審査する；',
    s10_i2: '追加書類を要請する；',
    s10_i3: '非拘束的な決定を下す。',
    s10_p2: 'プラットフォームの決定は、適用法に基づく法的権利に取って代わるものではありません。',
    s11: '知的財産権',
    s11_p1: '広告主は提出したコンテンツの所有権を保持します。',
    s11_p2: '素材をアップロードすることにより、広告主はプラットフォームおよびスペース提供者に対し、キャンペーンの履行のみを目的として当該素材を使用・複製・表示する限定的・非独占的ライセンスを付与します。',
    s11_p3: 'スペース提供者は自身の掲載情報、画像、位置データの所有権を保持します。',
    s11_p4: 'プラットフォームはすべてのプラットフォームソフトウェア、ブランディング、システムの所有権を保持します。',
    s12: '禁止事項',
    s12_p1: 'ユーザーは以下のことを行ってはなりません：',
    s12_i1: '詐欺行為；',
    s12_i2: '誤解を招くまたは違法なコンテンツのアップロード；',
    s12_i3: '支払いの回避；',
    s12_i4: '手数料を回避するためにプラットフォーム外でユーザーに連絡すること；',
    s12_i5: 'レビューやキャンペーン結果の操作；',
    s12_i6: '虚偽の設置証明のアップロード。',
    s12_p2: '違反は即時の停止または解約につながる場合があります。',
    s13: '責任制限',
    s13_p1: '法律で許可される最大限の範囲で、プラットフォームは以下について責任を負いません：',
    s13_i1: 'キャンペーンのパフォーマンス不足；',
    s13_i2: '天候による損害、自然災害および破壊行為（第9.6条および第9.7条に定めるところによります）；',
    s13_i3: '第三者による遅延；',
    s13_i4: 'プラットフォームに起因しない印刷上の欠陥；',
    s13_i5: 'ユーザーの行為または不作為。',
    s13_p2: '総責任額は、当該キャンペーンに対してプラットフォームに支払われた総手数料を超えないものとします。',
    s14: '補償',
    s14_p1: 'ユーザーは、以下に起因するあらゆる請求、損失、損害、責任または費用について当社を補償し、免責することに同意します：',
    s14_i1: '本規約の違反；',
    s14_i2: '違法な広告コンテンツ；',
    s14_i3: '第三者の権利の侵害；',
    s14_i4: '詐欺行為。',
    s15: 'アカウントの停止',
    s15_p1: 'プラットフォームは以下の理由でアカウントを停止または解約する場合があります：',
    s15_i1: '詐欺；',
    s15_i2: '未払い；',
    s15_i3: '繰り返される紛争；',
    s15_i4: 'プラットフォームの濫用；',
    s15_i5: '本規約の違反。',
    s16: '税金',
    s16_p1: 'ユーザーは消費税、売上税、所得税、その他適用される税金を含む自身の税金について責任を負います。プラットフォームは法律で要求される場合に税金を徴収する場合があります。',
    s17: 'データ保護',
    s17_p1: 'ユーザーデータはプラットフォームのプライバシーポリシーおよび適用されるデータ保護法に従って処理されます。ユーザーはアップロードした個人データに対する法的権利を有することを確認する責任があります。',
    s18: '準拠法',
    s18_p1: '本規約は、抵触法の原則にかかわらず、適用法に準拠します。紛争は管轄裁判所の専属管轄に服します。',
    s19: '規約の変更',
    s19_p1: 'プラットフォームはいつでも本規約を改定することができます。改定後もプラットフォームを継続して利用することにより、改定への同意とみなされます。',
    s20: 'お問い合わせ',
    s20_p1: '法的なお問い合わせはこちら：',
  },
  team: {
    title: 'チーム管理',
    subtitle: 'チームメンバーを管理し、招待を送信します',
    tabUsers: 'アクティブメンバー',
    tabInvitations: '招待',
    noUsers: 'まだアクティブなメンバーはいません',
    noUsersDesc: '招待を承認したユーザーがここに表示されます',
    statusVerified: '認証済み',
    statusPending: '保留中',
  },
  footer: {
    tagline: '屋外広告のオーナーと広告主をつなぐマーケットプレイス。シンプル、効率的、効果的。',
    platform: 'プラットフォーム',
    browseOutdoors: '屋外広告を見る',
    createAccount: 'アカウントを作成',
    logIn: 'ログイン',
    forBusinesses: '企業向け',
    registerBusiness: '企業を登録',
    listOutdoors: '広告スペースを掲載',
    runCampaigns: 'キャンペーンを実施',
    about: '会社概要',
    howItWorks: '使い方',
    mission: '私たちのミッション',
    contactUs: 'お問い合わせ',
    copyright: '© 2026 Scapow by Codify. 無断転載禁止。',
    privacy: 'プライバシー',
    terms: '利用規約',
  },
  language: {
    select: '言語',
    en: 'English',
    pt: 'Português',
    es: 'Español',
    de: 'Deutsch',
    zh: '中文',
    ja: '日本語',
    fr: 'Français',
    it: 'Italiano',
  },
  verification: {
    title: 'キャンペーン屋外広告の確認',
    subtitle: '確認待ちのアクティブなキャンペーン屋外広告に証明写真を提出してください。キャンペーン内のすべての屋外広告スロットの証明が提出されて初めて、キャンペーンの支払いが解放されます。',
    empty: '確認待ちの項目はありません',
    emptyDesc: 'アクティブなキャンペーン屋外広告はすべて最新の状態です。キャンペーンが開始されたら再度ご確認ください。',
    uploadProof: '証明写真をアップロード',
    uploaded: '証明を提出済み',
    uploadSuccess: '証明写真が正常に提出されました。',
    noName: 'キャンペーン屋外広告',
    locating: '位置を取得中…',
    awaitingVerification: '確認待ち',
    verified: '確認済み',
    partiallyVerified: '一部確認済み',
    backToCampaigns: 'キャンペーン一覧に戻る',
    noOutdoors: 'このキャンペーンの屋外広告スロットが見つかりません',
    pendingCount: '{{count}} 件待ち',
    notYetAvailable: '{{date}} から検証可能になります',
    viewProof: '証明写真を表示',
    proofAlt: '証明写真',
    deleteProof: '証明写真を削除',
    deleteProofSuccess: '証明写真を削除しました。',
    deleteProofConfirm: 'この証明写真を削除してもよろしいですか？この操作は元に戻せません。',
  },
  howItWorksPage: {
    title: '利用方法',
    subtitle: '屋外広告スペースをお持ちの方も、新しいオーディエンスにリーチしたい方も、Scapowがシンプルに実現します。',
    advertiserTab: '広告主の方へ',
    ppTab: 'スペース提供者の方へ',
    advertiserTitle: 'スケールでオーディエンスにリーチ',
    advertiserSubtitle: '屋外広告キャンペーンの計画、開始、追跡を--すべて一つの直感的なプラットフォームで。',
    adStep1Title: '最適なスペースを見つける',
    adStep1Desc: 'インタラクティブマップで検証済みの屋外広告スペースを数千件から検索できます。都市、フォーマット、サイズ、空き状況、日額で絞り込み、キャンペーンに最適な場所を見つけましょう。',
    adStep2Title: 'キャンペーンを作成する',
    adStep2Desc: '複数の屋外広告を選択して一つのキャンペーンにまとめます。期間を設定し、クリエイティブをアップロードしてプランを確認--代理店は不要です。',
    adStep3Title: '安心して支払う',
    adStep3Desc: '確定前に透明性のある料金明細を確認できます。当社プラットフォームと安全な決済ゲートウェイを通じて安心してお支払いいただけます。正式な請求書も発行されます--すべてが記録・追跡可能です。',
    adStep4Title: '各掲出を追跡する',
    adStep4Desc: 'キャンペーンが開始されると、スペース提供者が屋外広告の写真証明を提出します。ダッシュボードからステータスと確認事項を直接モニタリングできます。',
    ppTitle: 'スペースを収益に変える',
    ppSubtitle: '一度掲載するだけで、何千もの広告主にリーチし、自分のペースで収益を得られます。',
    ppStep1Title: 'スペースを掲載する',
    ppStep1Desc: '各屋外広告スペースの詳細な掲載情報を作成します。寸法、写真、料金、空き状況を追加してください。掲載情報が充実しているほど、より多くのキャンペーンを引き付けます。',
    ppStep2Title: 'キャンペーンとマッチングされる',
    ppStep2Desc: 'あなたのスペースは広告主の検索に自動的に表示されます。キャンペーンに選ばれると通知が届き、予約が確定します--交渉は不要です。',
    ppStep3Title: '掲出証明をアップロードする',
    ppStep3Desc: '屋外広告でキャンペーンが開始されたら、プラットフォームから写真証明をアップロードします。これが納品確認となり、支払いプロセスが開始されます。',
    ppStep4Title: '報酬を受け取る',
    ppStep4Desc: 'キャンペーン内のすべての屋外広告スロットについて掲出証明が提出されると、合意した条件に従って支払いが行われます。キャンペーン内のお客様のすべてのスロットが確認されてから支払いが処理されます--完全な納品が確認されてから支払いが行われる仕組みです。',
    ctaTitle: '始める準備はできていますか？',
    ctaSubtitle: 'すでにScapowで成長している何千もの企業に参加しましょう。',
    ctaAdvertiser: '広告を出す',
    ctaProvider: 'スペースを掲載する',
  },
  brand: {
    slogan: "it's ooh good!",
  },
  missionPage: {
    title: '私たちのミッション',
    subtitle: '屋外広告市場をつなぐ--すべてのスペースがインパクトを生み、すべてのキャンペーンがオーディエンスを見つけられるように。',
    coreTitle: '私たちを動かすもの',
    coreDesc: '屋外広告業界は断片化しています。優れたスペースが未使用のまま残り、キャンペーンはポテンシャルを発揮できていません。テクノロジーがそれを変えられると信じています--そのための手段がScapowです。',
    pillar1Title: 'リーチとインパクトの拡大',
    pillar1Desc: '私たちは広告主が一つの統合プラットフォームから複数のロケーションにわたる高インパクトな屋外広告キャンペーンを計画・実行できるよう支援します--運用コストをかけずにスケールで実現します。',
    pillar2Title: 'プロバイダーの収益最大化',
    pillar2Desc: '私たちはスペース提供者に広告需要の適格なプールへの直接アクセスを提供し、空き在庫を削減して、一貫した予測可能な収益を確保します。',
    pillar3Title: '静的OOH市場のつながり',
    pillar3Desc: '私たちは屋外広告業界が長年必要としてきたインフラを構築しています--供給と需要が効率的、公正に、そして大規模にマッチングする透明でデジタルファーストのマーケットプレイスです。',
    pillar4Title: '透明性を通じた信頼',
    pillar4Desc: '企業認証の確認から掲出の写真証明まで、Scapowプロセスのすべてのステップは監査可能で、説明責任があり、すべての関係者間の相互信頼の上に築かれています。',
    visionTitle: '私たちのビジョン',
    visionDesc: 'すべての屋外スペースがチャンスであり、すべてのブランドがオーディエンスが生活し、働き、移動するどこでも完璧なキャンバスを見つけられる世界。',
    closingTitle: 'OOHの未来を築く',
    closingDesc: 'Scapowはマーケットプレイス以上の存在です。スペース提供者、広告主、そして共同の成功を支えるテクノロジーを一つにつなぐ--屋外広告業界の結合組織です。',
  },
  contact: {
    label: 'お問い合わせ',
    title: 'お問い合わせ',
    subtitle: 'ご質問、フィードバック、またはご挨拶でも、ぜひご連絡ください。',
    infoTitle: 'お話しましょう',
    infoDesc: '機能、価格、その他何でも--私たちのチームがすべてのご質問にお答えする準備ができています。',
    responseTimeTitle: '迅速な対応',
    responseTimeDesc: '通常24時間以内にご返信いたします。',
    emailTitle: 'メールでのお問い合わせ',
    whatsappTitle: 'WhatsApp',
    formTitle: 'メッセージを送る',
    fieldName: 'お名前',
    fieldEmail: 'メールアドレス',
    fieldSubject: '件名',
    fieldMessage: 'メッセージ',
    namePlaceholder: '山田太郎',
    emailPlaceholder: 'you@example.com',
    subjectPlaceholder: 'どのようなご用件でしょうか？',
    messagePlaceholder: 'お問い合わせ内容をご記入ください…',
    submit: 'メッセージを送信',
    submitting: '送信中…',
    successTitle: 'メッセージを送信しました！',
    successDesc: 'お問い合わせありがとうございます。近日中にご連絡いたします。',
    backHome: 'ホームに戻る',
    errorRequired: 'このフィールドは必須です。',
    errorEmail: '有効なメールアドレスを入力してください。',
  },
  calendar: {
    calendarMonthsHint: '暦月単位（1日から末日まで）で予約します。1日をクリックして開始し、それ以降の日をクリックするとその月を追加、予約内をクリックすると短くなります。',
    startOnMonthFirstHint: '予約は月の1日から始まります。',
    fullMonthHint: '月単位の予約：開始日を選び、それ以降の日をクリックすると月を追加できます。各月は翌月の同じ日に終わります（1日に開始した場合はその月の末日）。予約内をクリックすると短くなります。',
    discountsTitle: '長く予約するほどお得',
    discountTier: '{{days}}日以上',
    discountsPickStart: '開始日を選ぶと、割引が適用される終了日が表示されます。',
    discountsHighlighted: '緑が濃いほど割引率が高くなります。タグは各割引の開始日を示します。',
    discountApplied: 'この{{count}}日間は{{percentage}}%割引',
    discountNextTier: 'あと{{days}}日追加すると{{percentage}}%割引',
    latestStartInfo: '開始日は{{date}}まで選択可能',
    blockedLegend: 'ブロック済み / 利用不可',
    pendingLegend: '保留中（未保存）',
    loading: '空き状況を読み込み中…',
    noticeRequired: '最早開始日: {{date}}（{{count}}日前の予約通知が必要）',
    minimumDaysError: '最低レンタル期間は {{count}} 日です - 選択期間を延ばしてください',
    overlapError: '選択した期間に予約済みの日付が含まれています - 連続する空き日のみ選択してください',
  },
  approvals: {
    thisBookingLegend: 'この予約',
    blockedSelection: 'ブロック期間：',
    blockedSelectionEmpty: 'カレンダーで開始日と終了日を選択してください。',
    title: '承認',
    subtitle: 'これらの支払い済みキャンペーンについて、アウトドアが利用可能か確認してください。',
    emptyTitle: '対応待ちはありません',
    emptyDesc: '広告主があなたのアウトドアを予約すると、ここに承認依頼が表示されます。',
    campaignFallback: 'キャンペーン',
    outdoorsToReview: '確認するアウトドア：{{count}}件',
    startsOn: '開始日：{{date}}',
    answerBy: '回答期限：{{date}}',
    review: '確認する',
    youEarn: '受取額',
    backToList: '承認一覧に戻る',
    reviewEyebrow: '承認依頼',
    summaryLine: 'アウトドア：{{count}}件 · 受取額 {{value}}',
    deadlineNotice: '{{date}}までに回答してください。期限内に回答がないアウトドアはキャンペーンから外れます。',
    progress: '{{total}}件中{{answered}}件回答済み',
    approveAll: 'すべて承認',
    available: '利用可能',
    unavailable: '利用不可',
    decisionFor: '{{name}}は利用可能ですか？',
    decisionRequired: '回答を選択してください。',
    blockedHint: 'このアウトドアがすでに埋まっている期間を入力してください。その日程をブロックします。',
    blockedFrom: 'ブロック開始日',
    blockedTo: 'ブロック終了日',
    blockedRequired: '両方の日付が必要です。',
    blockedOrder: '終了日は開始日以降にしてください。',
    viewCreative: '{{name}}のクリエイティブを表示',
    noCreative: 'クリエイティブはまだありません',
    feedbackMandatory: 'すべてのアウトドアに回答が必要です。',
    submit: '回答を送信',
    fixBeforeSubmit: 'すべてのアウトドアに回答し、ブロック日程を確認してください。',
    confirmTitle: '回答を送信しますか？',
    confirmSummary: '利用可能：{{approved}} · 利用不可：{{unavailable}}',
    confirmNote: '送信後は回答を変更できません。',
    submitted: 'ありがとうございます。回答を送信しました。',
    submitError: '回答を送信できませんでした。',
    allAnsweredTitle: '回答済み',
    allAnsweredDesc: 'このキャンペーンのすべてのアウトドアに回答済みです。',
    loadErrorTitle: 'この承認は利用できません',
    loadErrorDesc: 'すでに回答済みか、キャンペーンがキャンセルされた可能性があります。',
  },
  status: {
    installment: {
      SCHEDULED: '予定',
      PROCESSING: '処理中',
      PAID: '支払済み',
      FAILED: '失敗',
      CANCELLED: 'キャンセル',
    },
    campaign: {
      PENDING: '下書き',
      AWAITING_PAYMENT: '支払い待ち',
      CONFIRMING: '提供者の確認待ち',
      AWAITING_CONFIRMATION: '判断が必要',
      READY: '確定',
      RUNNING: '掲出中',
      COMPLETED: '完了',
      CANCELLED: 'キャンセル済み',
      UNAVAILABLE: '利用不可',
    },
    payment: {
      PENDING: '未払い',
      VALIDATING_PAYMENT: '支払い確認中',
      MANUAL_VALIDATION: '審査中',
      TRANSFER_REQUESTED: '振込依頼済み',
      PAID: '支払済み',
      CANCELLED: 'キャンセル済み',
      PARTIALLY_REFUNDED: '一部返金済み',
      FULLY_REFUNDED: '返金済み',
      FAILED: '失敗',
    },
    campaignOutdoor: {
      PENDING: '証明待ち',
      VERIFYING: '証明を確認中',
      FOR_MANUAL_APPROVAL: '証明を審査中',
      APPROVED: '証明承認済み',
      REJECTED: '証明却下',
      REFUNDED: '返金済み',
      CANCELLED: 'キャンセル済み',
    },
    proof: {
      PENDING: '保留中',
      VALID: '有効',
      MANUAL_VALIDATION: '審査中',
      INVALID: '無効',
    },
    paymentType: {
      BUYING_ADS: '広告購入',
      SELLING_ADS: '提供者への支払い',
      REFUND_BUYING_PART: '広告主への返金',
      REFUND_SELLING_PART: '提供者からの返金',
      PLACEMENT_PROVIDER_DEBT: '提供者の債務',
      PLACEMENT_PROVIDER_CANCELLATION_FEE: 'キャンセル補償',
    },
  },
  offlineCampaigns: {
    creativesTitle: 'クリエイティブ',
    creativesSubtitle: '設置するアートワークです。サイズは自由です。各アウトドアへの合わせ方はお任せします。',
    uploadCreatives: 'クリエイティブをアップロード',
    noCreatives: 'クリエイティブはまだありません。クリックしてJPG・PNG・TIFF・PDFファイルをアップロードしてください。',
    creativesUploaded: 'クリエイティブをアップロードしました。',
    creativeRemoved: 'クリエイティブを削除しました。',
    removeCreative: 'クリエイティブを削除',
    removeCreativeConfirm: 'このクリエイティブを削除しますか？元に戻せません。',
    downloadOriginal: '元ファイルをダウンロード',
    filesTitle: 'ファイル',
    filesSubtitle: '契約書、ブリーフなど、このキャンペーンのその他のファイル。',
    uploadFiles: 'ファイルをアップロード',
    noFiles: 'アップロードされたファイルはまだありません。',
    filesUploaded: 'ファイルをアップロードしました。',
    fileRemoved: 'ファイルを削除しました。',
    removeFile: 'ファイルを削除',
    removeFileConfirm: '「{{name}}」を削除しますか？元に戻せません。',
    download: 'ダウンロード',
    remove: '削除',
    outdoorsTitle: 'アウトドア',
    noOutdoors: 'このキャンペーンにはまだアウトドアがありません。',
    modalTitle: 'オフラインキャンペーンに追加',
    newTitle: '新しいオフラインキャンペーン',
    pickTitle: 'オフラインキャンペーンを選択',
    datesTitle: '日付を選択',
    doneTitle: 'アウトドアを追加しました',
    forOutdoor: 'アウトドア：',
    optionNew: '新規作成',
    optionNewDesc: 'Scapow以外で販売した予約のキャンペーンを作成します。',
    optionPick: '既存から選択',
    optionPickDesc: 'お持ちのオフラインキャンペーンに追加します。',
    name: 'キャンペーン名',
    nameRequired: 'キャンペーン名を入力してください。',
    details: '詳細',
    detailsHint: '例：販売先のクライアントやチャネル。',
    notes: 'メモ',
    notesHint: '社内メモ - チームのみに表示されます。',
    instructions: '指示',
    instructionsHint: 'クリエイティブを設置する担当者向け。',
    createAndContinue: '作成して続行',
    createError: 'オフラインキャンペーンを作成できませんでした。',
    addError: 'アウトドアをキャンペーンに追加できませんでした。',
    noneYet: 'オフラインキャンペーンはまだありません。',
    outdoorsCount: 'アウトドア：{{count}}件',
    createdOn: '{{date}}作成',
    datesIntro: '「{{campaign}}」でこのアウトドアを予約する期間を選んでください。既に埋まっている日付は表示され、選択できません。',
    pickDates: 'カレンダーで開始日と終了日を選んでください。',
    addToCampaign: 'キャンペーンに追加',
    doneMessage: '{{outdoor}}を「{{campaign}}」に追加しました。',
    doneHint: 'これらの日付は他の予約に対してブロックされました。',
    backToSearch: '検索に戻る',
    getAvailability: '空き状況を確認',
    clearAvailability: '空き状況をクリア',
    availabilityTitle: '空き状況を確認',
    availabilityHint: '開始日と終了日を選ぶと、期間中ずっと空いているアウトドアのみ表示されます。',
    showAvailable: '空いているアウトドアを表示',
    dimensionsLabel: 'サイズ',
    noMatches: '条件に一致するアウトドアはありません',
    noMatchesHint: '別のサイズや日付を試すか、フィルターをクリアしてください。',
    clearFilters: 'フィルターをクリア',
    addButton: 'オフラインキャンペーンに追加',
    addTooltip: 'Scapow以外で予約されたキャンペーンに追加',
  },
};

export default ja;
